const messages = {
	en: {
		edit: "Edit",
		delete: "Delete",
		cancel: "Cancel",
		save: "Save",
		confirm: "Confirm",
		add_item: "Add new item",
		confirm_delete: "This will permanently delete it. Continue?",
		warning_title: "Warning",
		all: "All",
		filter: "Filter",
		filters: "Filters",
		reset: "Reset",
		operations: "Operations",
		passwords_dont_match: "Passwords do not match",
		password_too_short: "Passwords to short",
		password_too_week: "Password to week",
		used: "used",
		new: "new",
		accepted: "accepted",
		pending: "pending",
		rejected: "rejected",
		countries: {
			austria: "Austria",
			croatia: "Croatia",
			poland: "Poland",
			romania: "Romania",
			switzerland: "Switzerland",
			serbia: "Serbia",
			slovakia: "Slovakia",
			slovenia: "Slovenia",
			czech_republic: "Czech Republic",
			hungary: "Hungary"
		},

		login: {
			title: "Login",
			subtitle: "Login to flea-market",
			marketplace_title: "Salesianer Marketplace",
			microsoft_subtitle: "Sign in with your Salesianer Microsoft account",
			microsoft_button: "Login with Microsoft",
			sso_unavailable: "Microsoft sign-in is temporarily unavailable.",
			sso_not_configured: "Azure SSO is not configured yet.",
			no_access: "No marketplace access yet?",
			request_access: "Request access",
			email_address: "Email address",
			enter_email: "Enter email",
			never_share: "We'll never share your email with anyone else",
			password: "Password",
			login_button: "Login now"
		},
		request_access: {
			request_title: "Request access",
			sent_title: "Request sent",
			request_subtitle: "Tell us where you need Marketplace access.",
			sent_subtitle: "Someone will respond as soon as possible.",
			account: "Account",
			country: "Country / region",
			country_placeholder: "Select country / region",
			factory: "Plant",
			factory_placeholder: "Select plant",
			message: "Message",
			message_placeholder: "Role, plant, or business reason",
			back: "Back",
			submit: "Request access",
			success_message: "Your request has been sent to the responsible approvers.",
			back_to_login: "Back to login",
			send_failed: "Could not send request."
		},
		feedback: {
			page_title: "Feedback",
			message_placeholder: "Your feedback",
			message: "Feedback message",
			star_rating: "Star rating",
			send_feedback: "Send feedback"
		},
		menu: {
			last_stock_update: "Laundry stock updates",
			log_out: "Log out",
			dashboard: "Dashboard",
			my_stocks: "My stocks",
			my_orders: "My orders",
			administration: "Administration",
			users: "Users",
			access_management: "Access",
			power_user_allocation: "Power User allocation",
			location_setup: "Locations",
			factories: "Factories",
			right_groups: "Right groups",
			catalog_setup: "Catalogue",
			product_categories: "Product Categories",
			products: "Products",
			communication_setup: "Communication",
			email_templates: "Email templates",
			reports: "Reports",
			report_activity: "Orders & offers",
			report_stock_control: "Stock control",
			unordered_products: "Unordered products",
			orders: "Orders",
			offers: "Offers",
			lazy_users: "Lazy users",
			settings: "Global settings",
			change_password: "Change Password",
			imports: "Imports",
			lang: "Language",
			active_factory: "Plant",
			primary_factory: "Primary",
			active_factory_changed: "Active plant changed",
			my_profile: "Profile"
		},
		users: {
			page_title: "Users",
			name: "Name",
			email: "Email",
			factory_country: "Plant Country",
			factory_code: "Plant Code",
			filters: "Filters",
			search_placeholder: "Search name or email",
			sso_status: "SSO status",
			sso_last_login: "SSO last login",
			access_request: "Access request",
			no_location_selected: "No location selected",
			message: "Message",
			approve: "Approve",
			block: "Block",
			block_confirm: "Block this Microsoft access request?",
			pending_access: "Pending access",
			approved_access: "Approved",
			blocked_access: "Blocked",
			azure_object_id: "Azure object ID",
			dialog_title: "User data",
			password: "Password",
			repeat_password: "Repeat password",
			user_group: "User Group",
			user_factory: "User Factory",
			assigned_plants: "Assigned plants",
			primary_factory: "Primary",
			additional_factories: "Assigned plants",
			additional_factories_placeholder: "Select additional plants this user can manage",
			load_failed: "Could not load users. Please try again.",
			change_password: "Change password",
			wrong_password: "Wrong pasword",
			good_password: "Good password",
			password_change_success: "Password changed with success",
			password_dialog_title: "Change password"
		},
		power_user_allocation: {
			page_title: "Power User allocation",
			subtitle: "Country and plant coverage for Marketplace access approvals.",
			refresh: "Refresh",
			countries: "Countries",
			factories: "Plants",
			factories_short: "plants",
			power_users: "Power Users",
			system_admins: "System Admins",
			uncovered_plants: "Uncovered plants",
			no_power_users: "No Power User assigned",
			no_uncovered: "All plants covered",
			gaps: "Gaps",
			empty: "No allocation data found",
			load_failed: "Could not load Power User allocation. Please try again."
		},
		email_templates: {
			page_title: "Email templates",
			subtitle: "Preview and customize Marketplace notification emails without sending.",
			preview_only: "No emails sent",
			unsaved_changes: "Unsaved changes",
			save: "Save template",
			save_success: "Email template saved.",
			save_failed: "Could not save email template.",
			unsaved_leave_message: "There are unsaved email template changes. Leave anyway?",
			reload: "Reload",
			configuration: "Configuration",
			template: "Template",
			language: "Language",
			values: "Values",
			editor: "Template editor",
			reset_template: "Reset template",
			subject: "Subject",
			body: "Body",
			bold: "Bold",
			italic: "Italic",
			underline: "Underline",
			clear_format: "Clear formatting",
			numbered_list: "Numbered list",
			bullet_list: "Bullet list",
			indent: "Indent",
			outdent: "Outdent",
			link: "Link",
			unlink: "Remove link",
			link_url_placeholder: "Enter link URL",
			table: "Table",
			horizontal_rule: "Horizontal line",
			format: "Format",
			paragraph: "Paragraph",
			heading: "Heading",
			subheading: "Subheading",
			note: "Small note",
			quote: "Quote",
			fullscreen: "Fullscreen editor",
			exit_fullscreen: "Exit fullscreen",
			preview: "Email preview",
			update_preview: "Update preview",
			event: "Event",
			empty_preview: "No preview yet.",
			load_failed: "Could not load email templates.",
			preview_failed: "Could not render email preview."
		},
		factories: {
			page_title: "Factories",
			email: "Email",
			notify_for_invoice_approval: "Notify for invoice on approval",
			filters: "Filters",
			search_placeholder: "Search country, code, email or address",
			invoice_notification: "Invoice notification",
			notify_enabled: "Notification enabled",
			notify_disabled: "No notification",
			address: "Address",
			name: "Name",
			country: "Country",
			code: "Factory Code",
			dialog_title: "Factory data"
		},
		right_groups: {
			page_title: "Right groups",
			dialog_title: "Right group data",
			name: "Name",
			group_rights: "Group rights",
			all_rights: "All rights",
			selected_rights: "Selected"
		},
		categories: {
			page_title: "Product categories",
			name: "Name",
			old_product_price: "Price for used item",
			proposed_by_user: "Proposed by user",
			dialog_title: "Category data",
			request_dialog_title: "Request new category",
			basic_information: "Category details",
			submit_request: "Submit request",
			filters: "Filters",
			search_placeholder: "Search category or proposer",
			approval_status: "Approval status",
			status: "Status",
			approved: "Approved",
			pending: "Pending",
			total_categories: "Categories",
			total: "Total",
			list_title: "Category list",
			sorted_by_newest: "Sorted by newest request",
			empty_results: "No categories found",
			load_failed: "Could not load categories. Please try again.",
			approve_failed: "Could not approve category. Please try again.",
			delete_failed: "Could not delete category. Please try again.",
			approve: "Approve",
			operations: "Operations",
			confirm_approve: "Approve this proposed category. Continue?"
		},
		products: {
			page_title: "Products",
			name: "Name",
			old_product_price: "Price for used item",
			proposed_by_user: "Proposed by user",
			dialog_title: "Product data",
			request_dialog_title: "Request new product",
			basic_information: "Product details",
			product_image: "Product image",
			upload_image: "Upload image",
			upload_hint: "JPG/PNG files under 500kb",
			preview: "Preview",
			no_image_selected: "No image uploaded",
			submit_request: "Submit request",
			category: "Category",
			description: "Description",
			image: "Image",
			article_number: "Article number",
			filters: "Filters",
			search_placeholder: "Search article, name or description",
			approval_status: "Approval status",
			status: "Status",
			approved: "Approved",
			pending: "Pending",
			total_products: "Products",
			total: "Total",
			list_title: "Product list",
			sorted_by_newest: "Sorted by newest request",
			empty_results: "No products found",
			load_failed: "Could not load products. Please try again.",
			approve: "Approve",
			confirm_approve: "Approve this proposed product. Continue?",
			marketplace_price: "Marketplace price",
			marketplace_price_hint: "Leave empty to keep this article unusable until a price is set.",
			missing_price: "Missing price",
			catalog: "Catalog",
			catalog_status: "Catalog status",
			manual_or_legacy: "Manual / legacy",
			required_name: "Name is required",
			required_article_number: "Article number is required",
			required_description: "Description is required",
			required_category: "Category is required",
			required_old_product_price: "Price for used item is required"
		},
		mystocks: {
			page_title: "My stocks",
			last_modified_date: "Last modification date",
			first_upload_date: "First upload date",
			new_products: "New Products",
			old_products: "Used Products",
			product: "Product",
			code: "Code",
			filters: "Filters",
			filter: "Filter",
			reset: "Reset",
			description: "Description",
			stock: "Stock",
			stocks_updated_with_success: "Stocks updated with success!",
			used_in_stock: "Used (qty.)",
			new_in_stock: "New (qty.)",
			price: "Price",
			only_available_for_new_products: "Only available for new products",
			new_products_in_stock: "New products in stock ( not used ones )",
			used_products_in_stock: "Used products in stock ( not new ones )",
			import_from_csv: "Import from CSV file:",
			choose_csv_file: "Choose CSV file",
			upload_csv_file: "Upload to server",
			example_csv_file: "Example CSV file",
			please_check: "Please check ",
			columns_used_in_csv: "Columns: Article number, Used quantity",
			total_products: "Products",
			with_used_quantity: "with stock",
			search_article: "Search article code",
			stock_list: "Stock list",
			sorted_by_activity: "Sorted by last activity",
			total: "Total",
			empty_results: "No stock products found",
			upload_errors: "Upload errors",
			article_number: "Article number",
			load_failed: "Could not load stock data. Please try again.",
			save_failed: "Could not save stock quantity. Please try again.",
			laundry_offer_scope: "Offers for the selected laundry",
			laundry: "Laundry",
			no_laundry_selected: "No laundry selected",
			create_offer: "Create offer",
			active_offers: "Active offers",
			available_quantity: "Available quantity",
			ordered_quantity: "Ordered quantity",
			estimated_value: "Estimated value",
			usable_products: "Usable products",
			need_price: "need price",
			last_updated_by: "Updated by",
			operations: "Operations",
			close_offer: "Close offer",
			confirm_close_offer: "Set this offer quantity to zero and close it?",
			publish_offer: "Publish offer",
			search_product_placeholder: "Search article number or name",
			product_search_starter: "Showing suggested usable articles. Type to refine.",
			product_search_results: "Filtered usable articles",
			no_usable_products_found: "No usable products found",
			marketplace_offers: "active offers",
			existing_offer: "Existing offer",
			offer_saved: "Offer saved.",
			product_search_failed: "Could not search products.",
			select_product_first: "Please select an article first.",
			enter_quantity_first: "Please enter a quantity."
		},
		dashboard: {
			page_title: "Dashboard",
			unique_id: "Id",
			factory_code: "Factory code",
			seller_name: "Seller name",
			created_date: "Created",
			article_info: "Article info",
			order_status: "Order status",
			product_status: "Status",
			quantity: "Quantity",
			price: "Price",
			order: "Order",
			own_offer: "My offer",
			own_offer_hint: "This is your active plant's own offer, so it cannot be ordered here.",
			operations: "Operations",
			article_code: "Article Code:",
			search_article: "Search article code",
			quantity_range: "Quantity range:",
			min_quantity: "Min",
			max_quantity: "Max",
			category: "Category",
			preview_seller: "Preview as seller",
			preview_seller_placeholder: "Select seller",
			used: "Used",
			new: "New",
			status: "Status",
			available_offers: "Offers",
			total: "Total",
			stock_offers: "Stock offers",
			sorted_by_id: "Sorted by newest ID",
			empty_results: "No stock offers found"
		},
		buy_dialog: {
			dialog_title: "New Order",
			quantity: "Quantity",
			price: "Price",
			request_value: "Request Value",
			confirm_order: "Confirm Order"
		},
		settings: {
			page_title: "Global Settings",
			saved_success: "Saved succesfully!",
			smtp_host: "SMTP Host",
			smtp_port: "SMTP Port",
			smtp_user: "SMTP User",
			smtp_pass: "SMTP Pass",
			system_email: "System Email",
			system_name: "System Name",
			system_delivery_notice_number: "Starting delivery notice number",
			invoice_email: "Invoice department email",
			newsletter_subject:
				"Newsletter mail subject ( use [month] for month name )",
			newsletter_body: "Newsletter body",
			request_accepted_subject: "Request accepted mail subject",
			request_accepted_body:
				"Request accepted mail body ( use [link] for my orders page link )",
			request_rejected_subject: "Request rejected mail subject",
			request_rejected_body:
				"Request rejected mail body ( use [link] for my orders page link and [reason] for reason explanation )",
			new_request_subject: "New request mail subject",
			new_request_body: "New request mail body",

			request_feedback_subject: "Request feedback mail subject",
			request_feedback_message: "Request feedback mail message",

			bad_feedback_subject: "Bad feedback mail subject",
			bad_feedback_message: "Bad feedback mail body",

			notify_powerusers_to_update_stocks_subject:
				"Notify powerusers to update stocks subject",
			notify_powerusers_to_update_stocks_message:
				"Notify powerusers to update stocks message",

			monthly_notify_invoice_department_subject:
				"Monthly notify invoice department with last month orders subject"
		},
		myorders: {
			page_title: "My orders",
			unique_id: "Id",
			filter_status: "Status",
			factory_code: "Factory code",
			seller_name: "Seller name",
			buyer_name: "Buyer name",
			buyer_factory_code: "Buyer Factory",
			article_info: "Article info",
			order_status: "Order status",
			product_status: "Status",
			request_date: "Request Date",
			quantity: "Quantity",
			price: "Price",
			order: "Order now",
			operations: "Operations",
			approve: "Approve",
			reject: "Reject",
			are_you_sure_you_approve: "Are you sure to approve this order?",
			attention_you_need_to_attach_invoice_to_delivery:
				"Attention! You have to attach the invoice to the delivery note!",
			rejection_reason: "Rejection reason",
			wrong_validate_reason: "Wrong validation reason!",
			no_action: "No action.",
			download_delivery_note: "Delivery Note",
			reason: "Reason",
			total_orders: "Orders",
			orders: "Orders",
			sorted_by_newest: "Sorted by newest request",
			total: "Total",
			empty_results: "No orders found",
			load_failed: "Could not load orders. Please try again."
		},
		report_unordered_products:{
			page_title: "Unordered products",
			subtitle: "Open used-stock offers with available quantity, compared with order activity.",
			rows: "Rows",
			laundries: "Laundries",
			open_quantity: "Open quantity",
			never_ordered: "Never ordered",
			filters: "Filters",
			search_placeholder: "Search laundry, article number or product",
			only_never_ordered: "Only never ordered",
			refresh: "Refresh",
			reset: "Reset",
			stock_list: "Stock with low/no order activity",
			sorted_by_laundry: "Grouped by laundry and article",
			total: "Total",
			empty_results: "No unordered stock found",
			article_info: "Article info",
			ordering_signal: "Order activity",
			has_orders: "Has orders",
			load_failed: "Could not load unordered products.",
			factory_code: "Factory",
			article_number: "Article Number",
			product_name: "Article",
			first_upload_date: "First upload date",
			current_quantity: "Open Quantity",
			ordered_quantity: "Ordered Quantity",
			export_to_excel: "Export to excel",
		},
		report_order: {
			page_title: "Orders report",
			total_orders: "Orders",
			orders: "Orders",
			total: "Total",
			sorted_by_id: "Sorted by newest ID",
			empty_results: "No orders found",
			unique_id: "Id",
			dates: "Dates",
			start_date: "Start date",
			end_date: "End date",
			factory_code: "Factory code",
			seller_name: "Seller name",
			article_info: "Article info",
			order_status: "Bestellstatus",
			product_status: "Status",
			quantity: "Quantity",
			request_date: "Request Date",
			buyer_name: "Buyer",
			buyer_factory_code: "Buyer Factory Code",
			price: "Price",
			order: "Order now",
			operations: "Operations",
			approve: "Approve",
			reject: "Reject",
			are_you_sure_you_approve: "Are you sure to approve this order?",
			rejection_reason: "Rejection reason",
			wrong_validate_reason: "Wrong validation reason!",
			no_action: "No action.",
			download_delivery_note: "Delivery Note",
			filters: "Filters",
			reset: "Reset",
			article_code: "Article Code:",
			search_article: "Search article code",
			category: "Category",
			all: "All",
			accepted: "Accepted",
			approved: "Approved",
			rejected: "Rejected",
			pending: "Pending",
			buyer: "Buyer",
			seller: "Seller",
			excel: "Excel",
			reason: "Grund"
		},
		report_offers: {
			page_title: "Offers report",
			available_offers: "Available offers",
			latest_offers: "Latest offers",
			sorted_by_id: "Sorted by newest ID",
			total: "Total",
			offer_id: "Id",
			created: "Created",
			factory: "Factory",
			seller: "Seller",
			article_info: "Article info",
			status: "Status",
			quantity: "Quantity",
			price: "Price",
			excel: "Excel",
			empty_results: "No offers"
		},
		report_last_stock_update: {
			page_title: "Laundry stock activity",
			subtitle: "Laundry-level stock activity grouped by country, based on actual stock rows and visible Marketplace offers.",
			user: "User",
			factory: "Laundry",
			factories: "Laundries",
			factories_short: "laundries",
			country: "Country",
			countries: "Countries",
			responsible_power_users: "Responsible Power Users",
			stock_actors: "Stock actors",
			no_stock_actors: "No stock activity yet",
			factory_overview: "Laundry overview",
			grouped_by_country: "Grouped by country with current Marketplace offer activity.",
			total_factories: "Total",
			last_update: "Last update",
			days_since_update: "Days since update",
			days: "Days",
			active_offers: "Active offers",
			active_articles: "Active articles",
			active_quantity: "Open quantity",
			estimated_value: "Estimated value",
			needs_attention: "Needs attention",
			needs_attention_short: "attention",
			offers_short: "offers",
			pieces_short: "pcs",
			status_current: "Current",
			status_stale: "Stale",
			status_never: "Never updated",
			expand_all: "Expand all",
			collapse_all: "Collapse all",
			no_factory_data: "No laundry stock data found",
			load_failed: "Could not load laundry stock activity.",
			all_users_are_ok: "All laundries have current stock updates",
			export_to_excel: "Export to excel",
			never: "Never"
		},
		report_lazy_users: {
			page_title: "Lazy users report",
			inactive_users: "Inactive users",
			user: "User",
			factory: "Factory",
			all_users_are_ok: "All users are ok",
			days_since_last_login: "Days since last login",
			days_since_request: "Days since request",
			buyer: "Buyer",
			buyer_factory: "Buyer factory",
			days: "Days",
			not_responding_users: "Not responding users",
			inactive_users_export_to_excel: "Export to excel inactive users",
			not_responding_users_export_to_excel:
				"Export to excel not responding users",
			last_update: "Last update",
			never: "Never"
		},
		imports: {
			page_title: "Imports",
			import_from_csv: "Import from CSV file:",
			drop_csv_file_1: "Drop file here or",
			drop_csv_file_2: "click to upload",
			file_limit: "csv files with a size less than 500kb"
		},
		form_errors: {
			email_required: 'The "Email" field is required',
			address_required: 'The "Address" field is required',
			country_required: 'The "Country" field is required',
			short_code_required: 'The "Short code" field is required'
		},
		rights: {
			manage_right_groups: "Manage right groups",
			manage_users: "Manage users",
			manage_factories: "Manage factories",
			manage_categories: "Manage Categories",
			manage_products: "Manage Products",
			global_settings: "Global Settings",
			access_reports: "Access Reports",
			admin_menu_visible: "Admin Menu Visible",
			reports_menu_visible: "Reports Menu Visible"
		}
	},
	de: {
		edit: "Bearbeiten",
		delete: "Löschen",
		cancel: "Abbrechen",
		save: "Speichern",
		confirm: "Bestätigen",
		add_item: "Hinzufügen",
		confirm_delete:
			"Durch Bestätigen wird Punkt dauerhaft gelöscht. Fortfahren?",
		warning_title: "Warnung",
		all: "Alles",
		filter: "Filter",
		filters: "Filter",
		reset: "Abbruch",
		operations: "Transaktion",
		passwords_dont_match: "Passwörter stimmen nicht überein",
		password_too_short: "Passwörter zu kurz",
		password_too_week: "Passwörter in der Woche",
		used: "gebraucht",
		new: "neu",
		accepted: "Erledigt",
		pending: "Offen",
		rejected: "Abgelehnt",
		countries: {
			austria: "Österreich",
			croatia: "Kroatien",
			poland: "Polen",
			romania: "Rumänien",
			switzerland: "Schweiz",
			serbia: "Serbien",
			slovakia: "Slowakei",
			slovenia: "Slowenien",
			czech_republic: "Tschechien",
			hungary: "Ungarn"
		},

		login: {
			title: "Titel",
			subtitle: "Anmelden in flea-market",
			marketplace_title: "Salesianer Marketplace",
			microsoft_subtitle: "Mit Ihrem Salesianer Microsoft-Konto anmelden",
			microsoft_button: "Mit Microsoft anmelden",
			sso_unavailable: "Microsoft-Anmeldung ist vorübergehend nicht verfügbar.",
			sso_not_configured: "Azure SSO ist noch nicht konfiguriert.",
			no_access: "Noch keinen Marketplace-Zugang?",
			request_access: "Zugang anfragen",
			email_address: "Email-adresse",
			enter_email: "Bestätigen der Email-adresse",
			never_share: "Wir werden Ihre Email-adresse an niemanden weitergeben",
			password: "Passwort",
			login_button: "Anmelden"
		},
		request_access: {
			request_title: "Zugang anfragen",
			sent_title: "Anfrage gesendet",
			request_subtitle: "Sagen Sie uns, wofür Sie Marketplace-Zugang benötigen.",
			sent_subtitle: "Jemand wird sich so bald wie möglich melden.",
			account: "Konto",
			country: "Land / Region",
			country_placeholder: "Land / Region auswählen",
			factory: "Betrieb",
			factory_placeholder: "Betrieb auswählen",
			message: "Nachricht",
			message_placeholder: "Rolle, Betrieb oder geschäftlicher Grund",
			back: "Zurück",
			submit: "Zugang anfragen",
			success_message: "Ihre Anfrage wurde an die zuständigen Freigeber gesendet.",
			back_to_login: "Zurück zur Anmeldung",
			send_failed: "Anfrage konnte nicht gesendet werden."
		},
		feedback: {
			page_title: "Feedback",
			message_placeholder: "Your feedback",
			message: "Feedback message",
			star_rating: "Star rating",
			send_feedback: "Send feedback"
		},
		menu: {
			last_stock_update: "Betriebs-Lageraktualisierung",
			log_out: "Abmelden...",
			dashboard: "Dashboard",
			my_stocks: "Mein Lagerstand",
			my_orders: "Meine Bestellungen",
			administration: "Administration",
			users: "Benutzer",
			access_management: "Zugang",
			power_user_allocation: "Power User Zuordnung",
			location_setup: "Standorte",
			factories: "Betrieb",
			right_groups: "Berechtigungsgruppe",
			catalog_setup: "Katalog",
			product_categories: "Produktkategorien",
			products: "Produkte",
			communication_setup: "Kommunikation",
			email_templates: "E-Mail-Vorlagen",
			reports: "Auswertungen",
			report_activity: "Bestellungen & Angebote",
			report_stock_control: "Lagerkontrolle",
			orders: "Bestellungen",
			offers: "Angebote",
			lazy_users: "Inaktive Benutzer",
			settings: "Allgemeine Einstellungen",
			change_password: "Passwort ändern",
			unordered_products: "Nicht bestellte Artikel",
			imports: "Importe",
			lang: "Sprache",
			active_factory: "Betrieb",
			primary_factory: "Primär",
			active_factory_changed: "Aktiver Betrieb geändert",
			my_profile: "Mein Profil"
		},
		users: {
			page_title: "Benutzer",
			name: "Name",
			email: "Email",
			factory_country: "Land des Betriebes",
			factory_code: "Betriebskürzel",
			filters: "Filter",
			search_placeholder: "Name oder Email suchen",
			sso_status: "SSO Status",
			sso_last_login: "Letzte SSO Anmeldung",
			access_request: "Zugangsanforderung",
			no_location_selected: "Kein Standort ausgewählt",
			message: "Nachricht",
			approve: "Genehmigen",
			block: "Blockieren",
			block_confirm: "Diese Microsoft-Zugangsanforderung blockieren?",
			pending_access: "Zugang ausstehend",
			approved_access: "Genehmigt",
			blocked_access: "Blockiert",
			azure_object_id: "Azure Objekt-ID",
			dialog_title: "Benutzerdaten",
			password: "Passwort",
			repeat_password: "Passwort wiederholen",
			user_group: "Benutzergruppe",
			user_factory: "Betrieb des Benutzers",
			assigned_plants: "Zugeordnete Betriebe",
			primary_factory: "Primär",
			additional_factories: "Zugeordnete Betriebe",
			additional_factories_placeholder: "Weitere Betriebe auswählen, die dieser Benutzer verwalten kann",
			load_failed: "Benutzer konnten nicht geladen werden. Bitte erneut versuchen.",
			change_password: "Passwort ändern",
			wrong_password: "Falsches Passwort",
			good_password: "Gutes Passwort",
			password_change_success: "Passwort wurde erfolgreich geändert",
			password_dialog_title: "Passwort ändern"
		},
		power_user_allocation: {
			page_title: "Power User Zuordnung",
			subtitle: "Länder- und Betriebsabdeckung für Marketplace-Zugangsfreigaben.",
			refresh: "Aktualisieren",
			countries: "Länder",
			factories: "Betriebe",
			factories_short: "Betriebe",
			power_users: "Power User",
			system_admins: "System Admins",
			uncovered_plants: "Nicht abgedeckte Betriebe",
			no_power_users: "Kein Power User zugeordnet",
			no_uncovered: "Alle Betriebe abgedeckt",
			gaps: "Lücken",
			empty: "Keine Zuordnungsdaten gefunden",
			load_failed: "Power User Zuordnung konnte nicht geladen werden."
		},
		email_templates: {
			page_title: "E-Mail-Vorlagen",
			subtitle: "Marketplace-Benachrichtigungen ansehen und anpassen, ohne E-Mails zu senden.",
			preview_only: "Es werden keine E-Mails gesendet",
			unsaved_changes: "Ungespeicherte Änderungen",
			save: "Vorlage speichern",
			save_success: "E-Mail-Vorlage wurde gespeichert.",
			save_failed: "E-Mail-Vorlage konnte nicht gespeichert werden.",
			unsaved_leave_message: "Es gibt ungespeicherte Änderungen an der E-Mail-Vorlage. Trotzdem verlassen?",
			reload: "Neu laden",
			configuration: "Konfiguration",
			template: "Vorlage",
			language: "Sprache",
			values: "Werte",
			editor: "Vorlageneditor",
			reset_template: "Vorlage zurücksetzen",
			subject: "Betreff",
			body: "Text",
			bold: "Fett",
			italic: "Kursiv",
			underline: "Unterstrichen",
			clear_format: "Formatierung entfernen",
			numbered_list: "Nummerierte Liste",
			bullet_list: "Aufzählung",
			indent: "Einrücken",
			outdent: "Ausrücken",
			link: "Link",
			unlink: "Link entfernen",
			link_url_placeholder: "Link-URL eingeben",
			table: "Tabelle",
			horizontal_rule: "Trennlinie",
			format: "Format",
			paragraph: "Absatz",
			heading: "Überschrift",
			subheading: "Unterüberschrift",
			note: "Kleiner Hinweis",
			quote: "Zitat",
			fullscreen: "Editor vergrößern",
			exit_fullscreen: "Vollbild verlassen",
			preview: "E-Mail-Vorschau",
			update_preview: "Vorschau aktualisieren",
			event: "Ereignis",
			empty_preview: "Noch keine Vorschau.",
			load_failed: "E-Mail-Vorlagen konnten nicht geladen werden.",
			preview_failed: "E-Mail-Vorschau konnte nicht gerendert werden."
		},
		factories: {
			page_title: "Betrieb",
			email: "Email",
			address: "Adresse",
			notify_for_invoice_approval: "Bei Genehmigung zur Rechnung benachrichtigen",
			filters: "Filter",
			search_placeholder: "Land, Code, Email oder Adresse suchen",
			invoice_notification: "Rechnungsbenachrichtigung",
			notify_enabled: "Benachrichtigung aktiv",
			notify_disabled: "Keine Benachrichtigung",
			name: "Name",
			country: "Land",
			code: "Betriebsabkürzung",
			dialog_title: "Betriebsdaten"
		},
		right_groups: {
			page_title: "Berechtigungsgruppe",
			dialog_title: "Berechtigungsgruppendaten",
			name: "Name",
			group_rights: "Berechtigungsgruppe",
			all_rights: "Alle Rechte",
			selected_rights: "ausgewählte Rechte",
			name_rquired: "Name ist erforderlich"
		},
		categories: {
			page_title: "Produktkategorien",
			name: "Name",
			old_product_price: "Preis für verwendeten Artikel",
			proposed_by_user: "Vorgeschlagen durch Benutzer",
			dialog_title: "Kategoriedaten",
			request_dialog_title: "Neue Kategorie anfragen",
			basic_information: "Kategoriedetails",
			submit_request: "Anfrage senden",
			filters: "Filter",
			search_placeholder: "Kategorie oder Benutzer suchen",
			approval_status: "Freigabestatus",
			status: "Status",
			approved: "Freigegeben",
			pending: "Ausstehend",
			total_categories: "Kategorien",
			total: "Gesamt",
			list_title: "Kategorienliste",
			sorted_by_newest: "Nach neuester Anfrage sortiert",
			empty_results: "Keine Kategorien gefunden",
			load_failed: "Kategorien konnten nicht geladen werden. Bitte erneut versuchen.",
			approve_failed: "Kategorie konnte nicht genehmigt werden. Bitte erneut versuchen.",
			delete_failed: "Kategorie konnte nicht gelöscht werden. Bitte erneut versuchen.",
			approve: "Genehmigen",
			operations: "Transaktion",
			confirm_approve: "Genehmigen Sie vorgeschlagene Kategorie. Fortfahren?"
		},
		products: {
			page_title: "Produkte",
			name: "Name",
			old_product_price: "Preis für verwendeten Artikel ",
			proposed_by_user: "Vorgeschlagen durch Benutzer",
			dialog_title: "Produktdaten",
			request_dialog_title: "Neues Produkt anfragen",
			basic_information: "Produktdetails",
			product_image: "Produktbild",
			upload_image: "Bild hochladen",
			upload_hint: "JPG/PNG-Dateien unter 500 KB",
			preview: "Vorschau",
			no_image_selected: "Kein Bild hochgeladen",
			submit_request: "Anfrage senden",
			category: "Kategorie",
			description: "Beschreibung",
			image: "Das Foto",
			article_number: "Artikelnummer",
			filters: "Filter",
			search_placeholder: "Artikel, Name oder Beschreibung suchen",
			approval_status: "Freigabestatus",
			status: "Status",
			approved: "Freigegeben",
			pending: "Ausstehend",
			total_products: "Produkte",
			total: "Gesamt",
			list_title: "Produktliste",
			sorted_by_newest: "Nach neuester Anfrage sortiert",
			empty_results: "Keine Produkte gefunden",
			load_failed: "Produkte konnten nicht geladen werden. Bitte erneut versuchen.",
			approve: "Genehmigen",
			confirm_approve: "Genehmigen Sie vorgeschlagene Produkt, Fortfahren?",
			marketplace_price: "Marketplace Preis",
			marketplace_price_hint: "Leer lassen, damit der Artikel bis zur Preiseingabe nicht verwendbar ist.",
			missing_price: "Preis fehlt",
			catalog: "Katalog",
			catalog_status: "Katalogstatus",
			manual_or_legacy: "Manuell / bisherig",
			required_name: "Name ist erforderlich",
			required_article_number: "Artikelnummer ist erforderlich",
			required_description: "Beschreibung ist erforderlich",
			required_category: "Kategorie ist erforderlich",
			required_old_product_price:
				"Preis für gebrauchte Artikel ist erforderlich"
		},
		mystocks: {
			page_title: "Mein Lagerstand",
			last_modified_date: "Datum der letzten Änderung",
			first_upload_date: "Datum des ersten Uploads",
			new_products: "Neue Produkte",
			old_products: "Verwendete Produkte",
			filters: "Filters",
			filter: "Filter",
			stocks_updated_with_success: "Lagerstände sind erfolgreich aktualisiert!",
			product: "Produkt",
			reset: "Abbruch",
			code: "Code",
			description: "Beschreibung",
			stock: "Lagerstand",
			used_in_stock: "verwendete (Menge)",
			new_in_stock: "Neue (Menge)",
			price: "Preis",
			only_available_for_new_products: "Nur verfügbar für neue Produkte",
			new_products_in_stock: "Neue Produkte im Stand (noch nicht verwendet)",
			used_products_in_stock: "Verwendete Produkte im Stand( keine Neuen )",
			import_from_csv: "Importieren von CSV Datei:",
			choose_csv_file: "Wähle CSV Datei",
			upload_csv_file: "Hochladen auf Server",
			example_csv_file: "Beispiel CSV Datei",
			please_check: "Bitte prüfen ",
			columns_used_in_csv: "Spalte: Produktnummer, verwendete Menge",
			total_products: "Produkte",
			with_used_quantity: "mit Lagerstand",
			search_article: "Artikelnummer suchen",
			stock_list: "Lagerstandsliste",
			sorted_by_activity: "Nach letzter Änderung sortiert",
			total: "Gesamt",
			empty_results: "Keine Lagerstände gefunden",
			upload_errors: "Upload-Fehler",
			article_number: "Artikelnummer",
			load_failed: "Lagerstände konnten nicht geladen werden. Bitte erneut versuchen.",
			save_failed: "Lagerstand konnte nicht gespeichert werden. Bitte erneut versuchen.",
			laundry_offer_scope: "Angebote des ausgewählten Betriebs",
			laundry: "Betrieb",
			no_laundry_selected: "Kein Betrieb ausgewählt",
			create_offer: "Angebot erstellen",
			active_offers: "Aktive Angebote",
			available_quantity: "Verfügbare Menge",
			ordered_quantity: "Bestellte Menge",
			estimated_value: "Geschätzter Wert",
			usable_products: "Nutzbare Produkte",
			need_price: "brauchen Preis",
			last_updated_by: "Aktualisiert von",
			operations: "Aktionen",
			close_offer: "Angebot schließen",
			confirm_close_offer: "Die Menge dieses Angebots auf null setzen und es schließen?",
			publish_offer: "Angebot veröffentlichen",
			search_product_placeholder: "Artikelnummer oder Name suchen",
			product_search_starter: "Nutzbare Artikel als Vorschlag. Tippen zum Eingrenzen.",
			product_search_results: "Gefilterte nutzbare Artikel",
			no_usable_products_found: "Keine nutzbaren Produkte gefunden",
			marketplace_offers: "aktive Angebote",
			existing_offer: "Bestehendes Angebot",
			offer_saved: "Angebot gespeichert.",
			product_search_failed: "Produkte konnten nicht gesucht werden.",
			select_product_first: "Bitte zuerst einen Artikel auswählen.",
			enter_quantity_first: "Bitte eine Menge eingeben."
		},
		dashboard: {
			page_title: "Dashboard",
			unique_id: "Id",
			factory_code: "Betriebskürzel",
			seller_name: "Verkäufername",
			created_date: "Erstellt",
			article_info: "Artikelinformation",
			product_status: "Produktstatus",
			quantity: "Menge",
			price: "Preis",
			order: "Bestellen",
			own_offer: "Eigenes",
			own_offer_hint: "Dies ist ein Angebot Ihres aktiven Betriebs und kann hier nicht bestellt werden.",
			operations: "Transaktion",
			article_code: "Artikelnummer:",
			search_article: "Artikelnummer suchen",
			quantity_range: "Mengenumfang:",
			min_quantity: "Min",
			max_quantity: "Max",
			category: "Kategorie",
			preview_seller: "Als Verkäufer anzeigen",
			preview_seller_placeholder: "Verkäufer wählen",
			used: "Gebraucht",
			new: "Neu",
			status: "Status",
			available_offers: "Angebote",
			total: "Gesamt",
			stock_offers: "Lagerangebote",
			sorted_by_id: "Nach neuester ID sortiert",
			empty_results: "Keine Lagerangebote gefunden"
		},
		buy_dialog: {
			dialog_title: "Neue Bestellung",
			quantity: "Menge",
			price: "Preis",
			request_value: "Angefragten Wert",
			confirm_order: "Bestellung bestätigen"
		},
		settings: {
			page_title: "Allgemeine Einstellungen",
			saved_success: "Speichern erfolgreich!",
			smtp_host: "SMTP Gast",
			smtp_port: "SMTP Port",
			smtp_user: "SMTP Benutzer",
			smtp_pass: "SMTP Zugang",
			system_email: "System Email",
			system_name: "System Name",
			system_delivery_notice_number: "Beginn der Lieferscheinnummer",
			invoice_email: "Email Rechnung",
			newsletter_subject:
				"Newsletter Mailüberschrift ( verwende [Monat] für Monatsname )",
			newsletter_body: "Newsletter Textkörper",
			request_accepted_subject: "Angefragte akzeptierte Mailüberschrift",
			request_accepted_body:
				"Angefragter akzeptierter Mailtextkörper ( Verwenden Sie [link] für meine Bestellungen )",
			request_rejected_subject: "Abgelehnte Anfrage Emailüberschrift",
			request_rejected_body:
				"Abgelehnte Anfrage Emailtextkörper ( Verwenden Sie [link] für meine Bestellungen und[reason]Beschreibung der Gründe )",
			new_request_subject: "Neue Anfrage Mailüberschrift",
			new_request_body: "Neue Anfrage Mailtextkörper",

			request_feedback_subject: "Feedback-Mail anfordern Mailüberschrift",
			request_feedback_message: "Feedback-Mail anfordern Mailtextkörper",

			bad_feedback_subject: "Ungültige Feedback-Mail Mailüberschrift",
			bad_feedback_message: "Ungültige Feedback-Mail Mailtextkörper",

			notify_powerusers_to_update_stocks_subject:
				"Benachrichtigen Sie den Power User um den aktuellen Bestand zu aktualisieren Mailüberschrift",
			notify_powerusers_to_update_stocks_message:
				"Benachrichtigen Sie den Power User um den aktuellen Bestand zu aktualisieren Mailtextkörper",

			monthly_notify_invoice_department_subject:
				"Bestellungen des letzten Monats für Fakturierung"
		},
		myorders: {
			page_title: "Meine Bestellungen",
			unique_id: "Id",
			filter_status: "Status",
			factory_code: "Betriebskürzel",
			seller_name: "Verkäufername",
			buyer_name: "Käufer",
			buyer_factory_code: "Käuferbetrieb",
			article_info: "Artikelinfo",
			order_status: "Bestellstatus",
			product_status: "Status",
			quantity: "Menge",
			price: "Preis",
			request_date: "Anfragedatum",
			order: "Jetzt Bestellen",
			operations: "Transaktion",
			approve: "Genehmigen",
			reject: "Ablehnen",
			are_you_sure_you_approve:
				"Sind Sie sicher diese Bestellung zu genehmigen?",
			attention_you_need_to_attach_invoice_to_delivery:
				"Beachtung! Sie müssen die Rechnung dem Lieferschein beifügen!",
			rejection_reason: "Ablehnungsgrund",
			wrong_validate_reason: "Unzulässiger Grund!",
			no_action: "Keine Durchführung.",
			download_delivery_note: "Lieferschein",
			reason: "Grund",
			total_orders: "Bestellungen",
			orders: "Bestellungen",
			sorted_by_newest: "Nach neuesten Bestellungen sortiert",
			total: "Gesamt",
			empty_results: "Keine Bestellungen gefunden",
			load_failed: "Bestellungen konnten nicht geladen werden. Bitte erneut versuchen."
		},
		report_unordered_products:{
			page_title: "Nicht bestellte Artikel",
			subtitle: "Offene Gebrauchtwaren-Angebote mit verfuegbarer Menge im Vergleich zur Bestellaktivitaet.",
			rows: "Zeilen",
			laundries: "Betriebe",
			open_quantity: "Offene Menge",
			never_ordered: "Nie bestellt",
			filters: "Filter",
			search_placeholder: "Betrieb, Artikelnummer oder Produkt suchen",
			only_never_ordered: "Nur nie bestellt",
			refresh: "Aktualisieren",
			reset: "Zuruecksetzen",
			stock_list: "Bestaende mit geringer/keiner Bestellaktivitaet",
			sorted_by_laundry: "Nach Betrieb und Artikel gruppiert",
			total: "Gesamt",
			empty_results: "Keine unbestellten Bestaende gefunden",
			article_info: "Artikelinfo",
			ordering_signal: "Bestellaktivitaet",
			has_orders: "Mit Bestellungen",
			load_failed: "Nicht bestellte Artikel konnten nicht geladen werden.",
			factory_code: "Betriebskürzel",
			article_number: "Artikel Info",
			product_name: "Artikel",
			first_upload_date: "Datum des ersten Uploads",
			current_quantity: "Offene Menge",
			ordered_quantity: "Bestellte Menge",
			export_to_excel: "Excel exportieren",
		},

		report_order: {
			page_title: "Bestellauswertung",
			total_orders: "Bestellungen",
			orders: "Bestellungen",
			total: "Gesamt",
			sorted_by_id: "Nach neuester ID sortiert",
			empty_results: "Keine Bestellungen gefunden",
			unique_id: "Id",
			dates: "Dates",
			start_date: "Startdatum",
			end_date: "Enddatum",
			factory_code: "Betriebskürzel",
			seller_name: "Verkäufername",
			article_info: "Artikel Info",
			request_date: "Anfragedatum",
			product_status: "Status",
			quantity: "Menge",
			price: "Preis",
			buyer_name: "Käufer",
			buyer_factory_code: "Käuferbetrieb",
			order: "Jetzt Bestellen",
			operations: "Transaktion",
			approve: "Genehmigen",
			reject: "Ablehnen",
			are_you_sure_you_approve:
				"Sind Sie sicher diese Bestellung zu genehmigen?",
			rejection_reason: "Ablehnungsgrund",
			wrong_validate_reason: "Unzulässiger Grund!",
			no_action: "Keine Aktion.",
			download_delivery_note: "Lieferschein",
			filters: "Filters",
			reset: "Abbruch",
			article_code: "Artikelnummer:",
			search_article: "Artikelnummer suchen",
			category: "Kategorie",
			all: "Alle",
			accepted: "Erledigt",
			approved: "Genehmigt",
			rejected: "Abgelehnt",
			pending: "Offen",
			buyer: "Käufer",
			seller: "Verkäufer",
			excel: "Excel",
			reason: "Grund"
		},
		report_offers: {
			page_title: "Angebotsauswertung",
			available_offers: "Verfügbare Angebote",
			latest_offers: "Neueste Angebote",
			sorted_by_id: "Nach neuester ID sortiert",
			total: "Gesamt",
			offer_id: "Id",
			created: "Erstellt",
			factory: "Betrieb",
			seller: "Verkäufer",
			article_info: "Artikel Info",
			status: "Status",
			quantity: "Menge",
			price: "Preis",
			excel: "Excel",
			empty_results: "Keine Angebote"
		},
		report_last_stock_update: {
			page_title: "Status der Betriebs-Lageraktualisierung",
			subtitle: "Lageraktivität pro Betrieb und Land, basierend auf tatsächlichen Lagerzeilen und sichtbaren Marketplace-Angeboten.",
			user: "Benutzer",
			factory: "Betrieb",
			factories: "Betriebe",
			factories_short: "Betriebe",
			country: "Land",
			countries: "Länder",
			responsible_power_users: "Verantwortliche Power User",
			stock_actors: "Aktive Lagerbenutzer",
			no_stock_actors: "Noch keine Lageraktivität",
			factory_overview: "Betriebsübersicht",
			grouped_by_country: "Nach Ländern gruppiert mit aktueller Marketplace-Angebotsaktivität.",
			total_factories: "Gesamt",
			last_update: "Letzte Lageraktualisierung",
			days_since_update: "Tage seit Aktualisierung",
			days: "Tage",
			active_offers: "Aktive Angebote",
			active_articles: "Aktive Artikel",
			active_quantity: "Offene Menge",
			estimated_value: "Geschätzter Wert",
			needs_attention: "Braucht Aufmerksamkeit",
			needs_attention_short: "offen",
			offers_short: "Angebote",
			pieces_short: "Stk.",
			status_current: "Aktuell",
			status_stale: "Veraltet",
			status_never: "Nie aktualisiert",
			expand_all: "Alle öffnen",
			collapse_all: "Alle schließen",
			no_factory_data: "Keine Betriebs-Lagerdaten gefunden",
			load_failed: "Status der Betriebs-Lageraktualisierung konnte nicht geladen werden.",
			all_users_are_ok: "Alle Betriebe haben aktuelle Lagerstände",
			export_to_excel: "Excel exportieren",
			never: "Nie"
		},
		report_lazy_users: {
			page_title: "Inaktive Benutzer Auswertung",
			inactive_users: "Inaktive Benutzer",
			user: "Benutzer",
			factory: "Betrieb",
			all_users_are_ok: "Alle Benutzer sind in Ordnung",
			days_since_last_login: "Tage seit letzter Anmeldung",
			days_since_request: "Tage seit letzter Anfrage",
			buyer: "Käufer",
			buyer_factory: "Betrieb des Käufers",
			days: "Tage",
			not_responding_users: "Keine Antwort von Benutzern",
			inactive_users_export_to_excel: "Inaktive Benutzer exportieren",
			not_responding_users_export_to_excel:
				"Benutzer die nicht reagieren, exportieren",
			last_update: "Tage seit der letzten Aktualisierung",
			never: "Keine Aktualisierung"
		},
		imports: {
			page_title: "Importe",
			import_from_csv: "Import aus CSV-Datei:",
			drop_csv_file_1: "Datei hier ablegen oder",
			drop_csv_file_2: "zum Hochladen klicken",
			file_limit: "CSV-Dateien mit einer Größe von weniger als 500 KB"
		},
		form_errors: {
			email_required: "Emailadresse ist erforderlich",
			address_required: "Adresse ist erforderlich",
			country_required: "Land ist erforderlich",
			short_code_required: "Betriebskürzel ist erforderlich"
		},
		rights: {
			manage_right_groups: "Verwalten Berechtigungsgruppen",
			manage_users: "Verwalten Benutzer",
			manage_factories: "Verwalten Betriebe",
			manage_categories: "Verwalten Produktkategorien",
			manage_products: "Verwalten Produkte",
			global_settings: "Allgemeine Einstellungen",
			access_reports: "Zugang Auswertungen",
			admin_menu_visible: "Administrationsmenü sichtbar",
			reports_menu_visible: "Auswertungsmenü sichtbar"
		}
	}
};

function isPlainObject(value) {
	return value && typeof value === "object" && !Array.isArray(value);
}

function mergeMessages(base, override) {
	var result = Object.assign({}, base);
	Object.keys(override || {}).forEach(function(key) {
		if(isPlainObject(result[key]) && isPlainObject(override[key])) {
			result[key] = mergeMessages(result[key], override[key]);
		} else {
			result[key] = override[key];
		}
	});
	return result;
}

const localLanguageOverrides = {
	cs: {
		countries: {
			austria: "Rakousko",
			croatia: "Chorvatsko",
			poland: "Polsko",
			romania: "Rumunsko",
			switzerland: "Švýcarsko",
			serbia: "Srbsko",
			slovakia: "Slovensko",
			slovenia: "Slovinsko",
			czech_republic: "Česko",
			hungary: "Maďarsko"
		},
		menu: { lang: "Jazyk" }
	},
	hr: {
		countries: {
			austria: "Austrija",
			croatia: "Hrvatska",
			poland: "Poljska",
			romania: "Rumunjska",
			switzerland: "Švicarska",
			serbia: "Srbija",
			slovakia: "Slovačka",
			slovenia: "Slovenija",
			czech_republic: "Češka",
			hungary: "Mađarska"
		},
		menu: { lang: "Jezik" }
	},
	hu: {
		countries: {
			austria: "Ausztria",
			croatia: "Horvátország",
			poland: "Lengyelország",
			romania: "Románia",
			switzerland: "Svájc",
			serbia: "Szerbia",
			slovakia: "Szlovákia",
			slovenia: "Szlovénia",
			czech_republic: "Csehország",
			hungary: "Magyarország"
		},
		menu: { lang: "Nyelv" }
	},
	pl: {
		countries: {
			austria: "Austria",
			croatia: "Chorwacja",
			poland: "Polska",
			romania: "Rumunia",
			switzerland: "Szwajcaria",
			serbia: "Serbia",
			slovakia: "Słowacja",
			slovenia: "Słowenia",
			czech_republic: "Czechy",
			hungary: "Węgry"
		},
		menu: { lang: "Język" }
	},
	ro: {
		countries: {
			austria: "Austria",
			croatia: "Croația",
			poland: "Polonia",
			romania: "România",
			switzerland: "Elveția",
			serbia: "Serbia",
			slovakia: "Slovacia",
			slovenia: "Slovenia",
			czech_republic: "Cehia",
			hungary: "Ungaria"
		},
		menu: { lang: "Limbă" }
	},
	sk: {
		countries: {
			austria: "Rakúsko",
			croatia: "Chorvátsko",
			poland: "Poľsko",
			romania: "Rumunsko",
			switzerland: "Švajčiarsko",
			serbia: "Srbsko",
			slovakia: "Slovensko",
			slovenia: "Slovinsko",
			czech_republic: "Česko",
			hungary: "Maďarsko"
		},
		menu: { lang: "Jazyk" }
	},
	sl: {
		countries: {
			austria: "Avstrija",
			croatia: "Hrvaška",
			poland: "Poljska",
			romania: "Romunija",
			switzerland: "Švica",
			serbia: "Srbija",
			slovakia: "Slovaška",
			slovenia: "Slovenija",
			czech_republic: "Češka",
			hungary: "Madžarska"
		},
		menu: { lang: "Jezik" }
	},
	sr: {
		countries: {
			austria: "Austrija",
			croatia: "Hrvatska",
			poland: "Poljska",
			romania: "Rumunija",
			switzerland: "Švajcarska",
			serbia: "Srbija",
			slovakia: "Slovačka",
			slovenia: "Slovenija",
			czech_republic: "Češka",
			hungary: "Mađarska"
		},
		menu: { lang: "Jezik" }
	}
};

const translatedUiOverrides = {
	cs: {
		edit: "Upravit",
		delete: "Smazat",
		cancel: "Zrušit",
		save: "Uložit",
		confirm: "Potvrdit",
		add_item: "Přidat položku",
		confirm_delete: "Tato položka bude trvale smazána. Pokračovat?",
		warning_title: "Upozornění",
		all: "Vše",
		filter: "Filtrovat",
		filters: "Filtry",
		reset: "Resetovat",
		operations: "Akce",
		used: "použité",
		new: "nové",
		accepted: "přijato",
		pending: "čeká",
		rejected: "zamítnuto",
		login: {
			title: "Přihlášení",
			subtitle: "Přihlášení do Marketplace",
			marketplace_title: "Salesianer Marketplace",
			microsoft_subtitle: "Přihlaste se svým účtem Microsoft Salesianer",
			microsoft_button: "Přihlásit přes Microsoft",
			sso_unavailable: "Přihlášení přes Microsoft je dočasně nedostupné.",
			sso_not_configured: "Azure SSO ještě není nakonfigurováno.",
			no_access: "Nemáte ještě přístup do Marketplace?",
			request_access: "Požádat o přístup",
			email_address: "E-mailová adresa",
			enter_email: "Zadejte e-mail",
			never_share: "Váš e-mail nikomu nepředáme",
			password: "Heslo",
			login_button: "Přihlásit se"
		},
		request_access: {
			request_title: "Požádat o přístup",
			sent_title: "Žádost odeslána",
			request_subtitle: "Napište nám, kde potřebujete přístup do Marketplace.",
			sent_subtitle: "Někdo se vám ozve co nejdříve.",
			account: "Účet",
			country: "Země / region",
			country_placeholder: "Vyberte zemi / region",
			factory: "Provoz",
			factory_placeholder: "Vyberte provoz",
			message: "Zpráva",
			message_placeholder: "Role, provoz nebo obchodní důvod",
			back: "Zpět",
			submit: "Požádat o přístup",
			success_message: "Vaše žádost byla odeslána odpovědným schvalovatelům.",
			back_to_login: "Zpět na přihlášení",
			send_failed: "Žádost se nepodařilo odeslat."
		},
		menu: {
			last_stock_update: "Aktualizace skladů provozů",
			log_out: "Odhlásit se",
			dashboard: "Dashboard",
			my_stocks: "Moje sklady",
			my_orders: "Moje objednávky",
			administration: "Administrace",
			users: "Uživatelé",
			power_user_allocation: "Přiřazení Power Userů",
			factories: "Provozy",
			right_groups: "Skupiny oprávnění",
			product_categories: "Kategorie produktů",
			products: "Produkty",
			reports: "Reporty",
			report_activity: "Objednávky a nabídky",
			report_stock_control: "Kontrola zásob",
			unordered_products: "Neobjednané položky",
			orders: "Objednávky",
			offers: "Nabídky",
			lazy_users: "Neaktivní uživatelé",
			settings: "Globální nastavení",
			change_password: "Změnit heslo",
			imports: "Importy",
			lang: "Jazyk",
			active_factory: "Provoz",
			primary_factory: "Primární",
			active_factory_changed: "Aktivní provoz změněn",
			my_profile: "Můj profil"
		},
		users: {
			page_title: "Uživatelé",
			name: "Jméno",
			email: "E-mail",
			factory_country: "Země provozu",
			factory_code: "Kód provozu",
			filters: "Filtry",
			search_placeholder: "Hledat jméno nebo e-mail",
			sso_status: "SSO stav",
			sso_last_login: "Poslední SSO přihlášení",
			access_request: "Žádost o přístup",
			no_location_selected: "Není vybráno žádné umístění",
			message: "Zpráva",
			approve: "Schválit",
			block: "Blokovat",
			block_confirm: "Blokovat tuto žádost o Microsoft přístup?",
			pending_access: "Přístup čeká",
			approved_access: "Schváleno",
			blocked_access: "Blokováno",
			azure_object_id: "Azure object ID",
			dialog_title: "Údaje uživatele",
			password: "Heslo",
			repeat_password: "Zopakovat heslo",
			user_group: "Skupina uživatelů",
			user_factory: "Provoz uživatele",
			assigned_plants: "Přiřazené provozy",
			primary_factory: "Primární",
			additional_factories: "Přiřazené provozy",
			additional_factories_placeholder: "Vyberte další provozy, které může uživatel spravovat",
			load_failed: "Uživatele se nepodařilo načíst. Zkuste to prosím znovu.",
			change_password: "Změnit heslo",
			wrong_password: "Špatné heslo",
			good_password: "Dobré heslo",
			password_change_success: "Heslo bylo úspěšně změněno",
			password_dialog_title: "Změnit heslo"
		},
		power_user_allocation: {
			page_title: "Přiřazení Power Userů",
			subtitle: "Pokrytí zemí a provozů pro schvalování přístupu do Marketplace.",
			refresh: "Obnovit",
			countries: "Země",
			factories: "Provozy",
			factories_short: "provozů",
			power_users: "Power Userové",
			system_admins: "Systémoví administrátoři",
			uncovered_plants: "Nepokryté provozy",
			no_power_users: "Není přiřazen žádný Power User",
			no_uncovered: "Všechny provozy jsou pokryty",
			gaps: "Mezery",
			empty: "Nenalezena žádná data přiřazení",
			load_failed: "Přiřazení Power Userů se nepodařilo načíst."
		},
		factories: {
			page_title: "Provozy",
			email: "E-mail",
			notify_for_invoice_approval: "Upozornit na fakturu při schválení",
			filters: "Filtry",
			search_placeholder: "Hledat zemi, kód, e-mail nebo adresu",
			invoice_notification: "Upozornění na fakturu",
			notify_enabled: "Upozornění aktivní",
			notify_disabled: "Bez upozornění",
			address: "Adresa",
			name: "Název",
			country: "Země",
			code: "Kód provozu",
			dialog_title: "Údaje provozu"
		},
		right_groups: {
			page_title: "Skupiny oprávnění",
			dialog_title: "Údaje skupiny oprávnění",
			name: "Název",
			group_rights: "Oprávnění skupiny",
			all_rights: "Všechna oprávnění",
			selected_rights: "Vybráno"
		},
		categories: {
			page_title: "Kategorie produktů",
			name: "Název",
			old_product_price: "Cena použité položky",
			proposed_by_user: "Navrhl uživatel",
			dialog_title: "Údaje kategorie",
			request_dialog_title: "Požádat o novou kategorii",
			basic_information: "Detaily kategorie",
			submit_request: "Odeslat žádost",
			filters: "Filtry",
			search_placeholder: "Hledat kategorii nebo navrhovatele",
			approval_status: "Stav schválení",
			status: "Stav",
			approved: "Schváleno",
			pending: "Čeká",
			total_categories: "Kategorie",
			total: "Celkem",
			list_title: "Seznam kategorií",
			sorted_by_newest: "Seřazeno podle nejnovější žádosti",
			empty_results: "Nenalezeny žádné kategorie",
			load_failed: "Kategorie se nepodařilo načíst.",
			approve_failed: "Kategorii se nepodařilo schválit.",
			delete_failed: "Kategorii se nepodařilo smazat.",
			approve: "Schválit",
			operations: "Akce",
			confirm_approve: "Schválit tuto navrženou kategorii. Pokračovat?"
		},
		products: {
			page_title: "Produkty",
			name: "Název",
			old_product_price: "Cena použité položky",
			proposed_by_user: "Navrhl uživatel",
			dialog_title: "Údaje produktu",
			request_dialog_title: "Požádat o nový produkt",
			basic_information: "Detaily produktu",
			product_image: "Obrázek produktu",
			upload_image: "Nahrát obrázek",
			upload_hint: "JPG/PNG do 500 KB",
			preview: "Náhled",
			no_image_selected: "Žádný obrázek nenahrán",
			submit_request: "Odeslat žádost",
			category: "Kategorie",
			description: "Popis",
			image: "Obrázek",
			article_number: "Číslo artiklu",
			filters: "Filtry",
			search_placeholder: "Hledat artikl, název nebo popis",
			approval_status: "Stav schválení",
			status: "Stav",
			approved: "Schváleno",
			pending: "Čeká",
			total_products: "Produkty",
			total: "Celkem",
			list_title: "Seznam produktů",
			sorted_by_newest: "Seřazeno podle nejnovější žádosti",
			empty_results: "Nenalezeny žádné produkty",
			load_failed: "Produkty se nepodařilo načíst.",
			approve: "Schválit",
			confirm_approve: "Schválit tento navržený produkt. Pokračovat?",
			marketplace_price: "Cena Marketplace",
			marketplace_price_hint: "Nechte prázdné, aby položka nebyla použitelná, dokud nebude zadána cena.",
			missing_price: "Chybí cena",
			catalog: "Katalog",
			catalog_status: "Stav katalogu",
			manual_or_legacy: "Ruční / původní",
			required_name: "Název je povinný",
			required_article_number: "Číslo artiklu je povinné",
			required_description: "Popis je povinný",
			required_category: "Kategorie je povinná",
			required_old_product_price: "Cena použité položky je povinná"
		},
		mystocks: {
			page_title: "Moje sklady",
			last_modified_date: "Datum poslední změny",
			first_upload_date: "Datum prvního nahrání",
			new_products: "Nové produkty",
			old_products: "Použité produkty",
			product: "Produkt",
			code: "Kód",
			filters: "Filtry",
			filter: "Filtrovat",
			reset: "Resetovat",
			description: "Popis",
			stock: "Sklad",
			stocks_updated_with_success: "Sklady byly úspěšně aktualizovány.",
			used_in_stock: "Použité (ks)",
			new_in_stock: "Nové (ks)",
			price: "Cena",
			only_available_for_new_products: "Dostupné pouze pro nové produkty",
			new_products_in_stock: "Nové produkty na skladě",
			used_products_in_stock: "Použité produkty na skladě",
			import_from_csv: "Import ze souboru CSV:",
			choose_csv_file: "Vybrat CSV soubor",
			upload_csv_file: "Nahrát na server",
			example_csv_file: "Vzorový CSV soubor",
			please_check: "Zkontrolujte prosím ",
			columns_used_in_csv: "Sloupce: číslo artiklu, použité množství",
			total_products: "Produkty",
			with_used_quantity: "se skladem",
			search_article: "Hledat číslo artiklu",
			stock_list: "Seznam skladů",
			sorted_by_activity: "Seřazeno podle poslední aktivity",
			total: "Celkem",
			empty_results: "Nenalezeny žádné skladové produkty",
			upload_errors: "Chyby nahrání",
			article_number: "Číslo artiklu",
			load_failed: "Skladová data se nepodařilo načíst.",
			save_failed: "Množství se nepodařilo uložit."
		},
		dashboard: {
			page_title: "Dashboard",
			unique_id: "Id",
			factory_code: "Kód provozu",
			seller_name: "Prodejce",
			created_date: "Vytvořeno",
			article_info: "Informace o artiklu",
			order_status: "Stav objednávky",
			product_status: "Stav",
			quantity: "Množství",
			price: "Cena",
			order: "Objednat",
			own_offer: "Moje nabídka",
			own_offer_hint: "Toto je nabídka vašeho aktivního provozu, proto ji zde nelze objednat.",
			operations: "Akce",
			article_code: "Číslo artiklu:",
			search_article: "Hledat číslo artiklu",
			quantity_range: "Rozsah množství:",
			min_quantity: "Min",
			max_quantity: "Max",
			category: "Kategorie",
			preview_seller: "Zobrazit jako prodejce",
			preview_seller_placeholder: "Vybrat prodejce",
			used: "Použité",
			new: "Nové",
			status: "Stav",
			available_offers: "Nabídky",
			total: "Celkem",
			stock_offers: "Skladové nabídky",
			sorted_by_id: "Seřazeno podle nejnovějšího ID",
			empty_results: "Nenalezeny žádné skladové nabídky"
		},
		buy_dialog: {
			dialog_title: "Nová objednávka",
			quantity: "Množství",
			price: "Cena",
			request_value: "Hodnota žádosti",
			confirm_order: "Potvrdit objednávku"
		},
		myorders: {
			page_title: "Moje objednávky",
			unique_id: "Id",
			filter_status: "Stav",
			factory_code: "Kód provozu",
			seller_name: "Prodejce",
			buyer_name: "Kupující",
			buyer_factory_code: "Provoz kupujícího",
			article_info: "Informace o artiklu",
			order_status: "Stav objednávky",
			product_status: "Stav",
			request_date: "Datum žádosti",
			quantity: "Množství",
			price: "Cena",
			order: "Objednat nyní",
			operations: "Akce",
			approve: "Schválit",
			reject: "Zamítnout",
			are_you_sure_you_approve: "Opravdu chcete tuto objednávku schválit?",
			attention_you_need_to_attach_invoice_to_delivery: "Pozor! Fakturu musíte přiložit k dodacímu listu.",
			rejection_reason: "Důvod zamítnutí",
			wrong_validate_reason: "Neplatný důvod.",
			no_action: "Žádná akce.",
			download_delivery_note: "Dodací list",
			reason: "Důvod",
			total_orders: "Objednávky",
			orders: "Objednávky",
			sorted_by_newest: "Seřazeno podle nejnovější žádosti",
			total: "Celkem",
			empty_results: "Nenalezeny žádné objednávky",
			load_failed: "Objednávky se nepodařilo načíst."
		},
		report_unordered_products: {
			page_title: "Neobjednané produkty",
			subtitle: "Otevřené nabídky použitého zboží s dostupným množstvím v porovnání s aktivitou objednávek.",
			rows: "Řádky",
			laundries: "Provozy",
			open_quantity: "Otevřené množství",
			never_ordered: "Nikdy neobjednáno",
			filters: "Filtry",
			search_placeholder: "Hledat provoz, číslo artiklu nebo produkt",
			only_never_ordered: "Pouze nikdy neobjednané",
			refresh: "Obnovit",
			reset: "Resetovat",
			stock_list: "Zásoby s nízkou/žádnou aktivitou objednávek",
			sorted_by_laundry: "Seskupeno podle provozu a artiklu",
			total: "Celkem",
			empty_results: "Nenalezeny žádné neobjednané zásoby",
			article_info: "Informace o artiklu",
			ordering_signal: "Aktivita objednávek",
			has_orders: "Má objednávky",
			load_failed: "Neobjednané produkty se nepodařilo načíst.",
			factory_code: "Provoz",
			article_number: "Číslo artiklu",
			product_name: "Artikl",
			first_upload_date: "Datum prvního nahrání",
			current_quantity: "Otevřené množství",
			ordered_quantity: "Objednané množství",
			export_to_excel: "Export do Excelu"
		},
		report_order: {
			page_title: "Report objednávek",
			total_orders: "Objednávky",
			orders: "Objednávky",
			total: "Celkem",
			sorted_by_id: "Seřazeno podle nejnovějšího ID",
			empty_results: "Nenalezeny žádné objednávky",
			unique_id: "Id",
			dates: "Data",
			factory_code: "Kód provozu",
			seller_name: "Prodejce",
			article_info: "Informace o artiklu",
			order_status: "Stav objednávky",
			product_status: "Stav",
			quantity: "Množství",
			request_date: "Datum žádosti",
			buyer_name: "Kupující",
			buyer_factory_code: "Provoz kupujícího",
			price: "Cena",
			order: "Objednat nyní",
			operations: "Akce",
			approve: "Schválit",
			reject: "Zamítnout",
			are_you_sure_you_approve: "Opravdu chcete tuto objednávku schválit?",
			rejection_reason: "Důvod zamítnutí",
			wrong_validate_reason: "Neplatný důvod.",
			no_action: "Žádná akce.",
			download_delivery_note: "Dodací list",
			filters: "Filtry",
			reset: "Resetovat",
			article_code: "Číslo artiklu:",
			search_article: "Hledat číslo artiklu",
			category: "Kategorie",
			all: "Vše",
			accepted: "Přijato",
			approved: "Schváleno",
			rejected: "Zamítnuto",
			pending: "Čeká",
			buyer: "Kupující",
			seller: "Prodejce",
			excel: "Excel",
			reason: "Důvod"
		},
		report_offers: {
			page_title: "Report nabídek",
			available_offers: "Dostupné nabídky",
			latest_offers: "Nejnovější nabídky",
			sorted_by_id: "Seřazeno podle nejnovějšího ID",
			total: "Celkem",
			offer_id: "Id",
			created: "Vytvořeno",
			factory: "Provoz",
			seller: "Prodejce",
			article_info: "Informace o artiklu",
			status: "Stav",
			quantity: "Množství",
			price: "Cena",
			excel: "Excel",
			empty_results: "Žádné nabídky"
		},
		report_last_stock_update: {
			page_title: "Stav aktualizace skladů provozů",
			subtitle: "Skladová aktivita podle provozu a země, podle skutečných skladových řádků a viditelných nabídek Marketplace.",
			user: "Uživatel",
			factory: "Provoz",
			factories: "Provozy",
			factories_short: "provozů",
			country: "Země",
			countries: "Země",
			responsible_power_users: "Odpovědní Power Userové",
			stock_actors: "Aktivní skladoví uživatelé",
			no_stock_actors: "Zatím žádná skladová aktivita",
			factory_overview: "Přehled provozů",
			grouped_by_country: "Seskupeno podle země s aktuální aktivitou nabídek Marketplace.",
			total_factories: "Celkem",
			last_update: "Poslední aktualizace",
			days_since_update: "Dny od aktualizace",
			days: "Dny",
			active_offers: "Aktivní nabídky",
			active_articles: "Aktivní artikly",
			active_quantity: "Otevřené množství",
			estimated_value: "Odhadovaná hodnota",
			needs_attention: "Vyžaduje pozornost",
			needs_attention_short: "pozornost",
			offers_short: "nabídky",
			pieces_short: "ks",
			status_current: "Aktuální",
			status_stale: "Zastaralé",
			status_never: "Nikdy neaktualizováno",
			expand_all: "Rozbalit vše",
			collapse_all: "Sbalit vše",
			no_factory_data: "Nebyla nalezena žádná skladová data provozů",
			load_failed: "Stav aktualizace skladů provozů se nepodařilo načíst.",
			all_users_are_ok: "Všechny provozy mají aktuální skladové aktualizace",
			export_to_excel: "Export do Excelu",
			never: "Nikdy"
		},
		report_lazy_users: {
			page_title: "Report neaktivních uživatelů",
			inactive_users: "Neaktivní uživatelé",
			user: "Uživatel",
			factory: "Provoz",
			all_users_are_ok: "Všichni uživatelé jsou v pořádku",
			days_since_last_login: "Dny od posledního přihlášení",
			days_since_request: "Dny od poslední žádosti",
			buyer: "Kupující",
			buyer_factory: "Provoz kupujícího",
			days: "Dny",
			not_responding_users: "Uživatelé bez reakce",
			inactive_users_export_to_excel: "Export neaktivních uživatelů do Excelu",
			not_responding_users_export_to_excel: "Export nereagujících uživatelů do Excelu",
			last_update: "Poslední aktualizace",
			never: "Nikdy"
		},
		imports: {
			page_title: "Importy",
			import_from_csv: "Import ze souboru CSV:",
			drop_csv_file_1: "Přetáhněte soubor sem nebo",
			drop_csv_file_2: "klikněte pro nahrání",
			file_limit: "CSV soubory menší než 500 KB"
		},
		form_errors: {
			email_required: "Pole e-mail je povinné",
			address_required: "Pole adresa je povinné",
			country_required: "Pole země je povinné",
			short_code_required: "Pole kód provozu je povinné"
		},
		rights: {
			manage_right_groups: "Spravovat skupiny oprávnění",
			manage_users: "Spravovat uživatele",
			manage_factories: "Spravovat provozy",
			manage_categories: "Spravovat kategorie",
			manage_products: "Spravovat produkty",
			global_settings: "Globální nastavení",
			access_reports: "Přístup k reportům",
			admin_menu_visible: "Administrátorské menu viditelné",
			reports_menu_visible: "Menu reportů viditelné"
		}
	},
	hr: {
		edit: "Uredi",
		delete: "Izbriši",
		cancel: "Odustani",
		save: "Spremi",
		confirm: "Potvrdi",
		add_item: "Dodaj stavku",
		confirm_delete: "Ova će stavka biti trajno izbrisana. Nastaviti?",
		warning_title: "Upozorenje",
		all: "Sve",
		filter: "Filtriraj",
		filters: "Filtri",
		reset: "Poništi",
		operations: "Radnje",
		used: "rabljeno",
		new: "novo",
		accepted: "prihvaćeno",
		pending: "na čekanju",
		rejected: "odbijeno",
		login: {
			title: "Prijava",
			subtitle: "Prijava u Marketplace",
			marketplace_title: "Salesianer Marketplace",
			microsoft_subtitle: "Prijavite se svojim Salesianer Microsoft računom",
			microsoft_button: "Prijava putem Microsofta",
			sso_unavailable: "Microsoft prijava trenutno nije dostupna.",
			sso_not_configured: "Azure SSO još nije konfiguriran.",
			no_access: "Još nemate pristup Marketplaceu?",
			request_access: "Zatraži pristup"
		},
		request_access: {
			request_title: "Zatraži pristup",
			sent_title: "Zahtjev poslan",
			request_subtitle: "Recite nam gdje trebate pristup Marketplaceu.",
			sent_subtitle: "Netko će odgovoriti što je prije moguće.",
			country: "Država / regija",
			country_placeholder: "Odaberite državu / regiju",
			factory: "Pogon",
			factory_placeholder: "Odaberite pogon",
			message: "Poruka",
			message_placeholder: "Uloga, pogon ili poslovni razlog",
			back: "Natrag",
			submit: "Zatraži pristup",
			success_message: "Vaš je zahtjev poslan odgovornim odobravateljima.",
			back_to_login: "Natrag na prijavu",
			send_failed: "Zahtjev nije moguće poslati."
		},
		menu: {
			last_stock_update: "Ažuriranja zaliha pogona",
			log_out: "Odjava",
			dashboard: "Nadzorna ploča",
			my_stocks: "Moje zalihe",
			my_orders: "Moje narudžbe",
			administration: "Administracija",
			users: "Korisnici",
			power_user_allocation: "Dodjela Power Usera",
			factories: "Pogoni",
			right_groups: "Grupe prava",
			product_categories: "Kategorije proizvoda",
			products: "Proizvodi",
			reports: "Izvještaji",
			report_activity: "Narudžbe i ponude",
			report_stock_control: "Kontrola zaliha",
			unordered_products: "Nenarucene stavke",
			orders: "Narudžbe",
			offers: "Ponude",
			lazy_users: "Neaktivni korisnici",
			settings: "Globalne postavke",
			change_password: "Promijeni lozinku",
			imports: "Uvozi",
			lang: "Jezik",
			active_factory: "Pogon",
			primary_factory: "Primarno",
			active_factory_changed: "Aktivni pogon promijenjen",
			my_profile: "Moj profil"
		},
		users: {
			page_title: "Korisnici",
			name: "Ime",
			email: "E-mail",
			factory_country: "Država pogona",
			factory_code: "Kod pogona",
			filters: "Filtri",
			search_placeholder: "Traži ime ili e-mail",
			sso_status: "SSO status",
			dialog_title: "Podaci korisnika",
			user_group: "Korisnička grupa",
			user_factory: "Pogon korisnika",
			assigned_plants: "Dodijeljeni pogoni",
			primary_factory: "Primarno",
			additional_factories: "Dodijeljeni pogoni",
			additional_factories_placeholder: "Odaberite dodatne pogone koje korisnik može upravljati",
			load_failed: "Korisnike nije moguće učitati. Pokušajte ponovno."
		},
		power_user_allocation: {
			page_title: "Dodjela Power Usera",
			subtitle: "Pokrivenost država i pogona za odobravanje pristupa Marketplaceu.",
			refresh: "Osvježi",
			countries: "Države",
			factories: "Pogoni",
			factories_short: "pogona",
			power_users: "Power Useri",
			system_admins: "Administratori sustava",
			uncovered_plants: "Nepokriveni pogoni",
			no_power_users: "Nema dodijeljenog Power Usera",
			no_uncovered: "Svi pogoni su pokriveni",
			gaps: "Praznine",
			empty: "Nema podataka o dodjeli",
			load_failed: "Dodjelu Power Usera nije moguće učitati."
		},
		factories: {
			page_title: "Pogoni",
			search_placeholder: "Traži državu, kod, e-mail ili adresu",
			country: "Država",
			code: "Kod pogona",
			address: "Adresa",
			name: "Naziv",
			email: "E-mail"
		},
		categories: {
			page_title: "Kategorije proizvoda",
			name: "Naziv",
			old_product_price: "Cijena rabljene stavke",
			proposed_by_user: "Predložio korisnik",
			approval_status: "Status odobrenja",
			status: "Status",
			approved: "Odobreno",
			pending: "Na čekanju",
			total: "Ukupno",
			list_title: "Popis kategorija",
			empty_results: "Nema pronađenih kategorija",
			approve: "Odobri"
		},
		products: {
			page_title: "Proizvodi",
			name: "Naziv",
			old_product_price: "Cijena rabljene stavke",
			category: "Kategorija",
			description: "Opis",
			article_number: "Broj artikla",
			filters: "Filtri",
			search_placeholder: "Traži artikl, naziv ili opis",
			approval_status: "Status odobrenja",
			status: "Status",
			approved: "Odobreno",
			pending: "Na čekanju",
			total_products: "Proizvodi",
			total: "Ukupno",
			list_title: "Popis proizvoda",
			empty_results: "Nema pronađenih proizvoda",
			approve: "Odobri",
			marketplace_price: "Marketplace cijena",
			missing_price: "Nedostaje cijena",
			catalog_status: "Status kataloga"
		},
		mystocks: {
			page_title: "Moje zalihe",
			total_products: "Proizvodi",
			with_used_quantity: "sa zalihom",
			search_article: "Traži kod artikla",
			stock_list: "Popis zaliha",
			sorted_by_activity: "Sortirano po zadnjoj aktivnosti",
			total: "Ukupno",
			empty_results: "Nema pronađenih proizvoda na zalihi",
			filters: "Filtri",
			import_from_csv: "Uvoz iz CSV datoteke:",
			choose_csv_file: "Odaberi CSV datoteku",
			upload_csv_file: "Učitaj na server",
			article_number: "Broj artikla",
			used_in_stock: "Rabljeno (kol.)",
			price: "Cijena"
		},
		dashboard: {
			page_title: "Nadzorna ploča",
			available_offers: "Ponude",
			stock_offers: "Ponude zaliha",
			sorted_by_id: "Sortirano po najnovijem ID-u",
			total: "Ukupno",
			factory_code: "Kod pogona",
			seller_name: "Prodavatelj",
			created_date: "Kreirano",
			article_info: "Informacije o artiklu",
			quantity: "Količina",
			price: "Cijena",
			order: "Naruči",
			operations: "Radnje",
			article_code: "Kod artikla:",
			search_article: "Traži kod artikla",
			quantity_range: "Raspon količine:",
			category: "Kategorija",
			preview_seller: "Prikaži kao prodavatelj",
			preview_seller_placeholder: "Odaberite prodavatelja",
			empty_results: "Nema pronađenih ponuda zaliha"
		},
		myorders: {
			page_title: "Moje narudžbe",
			total_orders: "Narudžbe",
			orders: "Narudžbe",
			sorted_by_newest: "Sortirano po najnovijem zahtjevu",
			total: "Ukupno",
			filter_status: "Status",
			factory_code: "Kod pogona",
			seller_name: "Prodavatelj",
			buyer_name: "Kupac",
			article_info: "Informacije o artiklu",
			quantity: "Količina",
			price: "Cijena",
			operations: "Radnje",
			approve: "Odobri",
			reject: "Odbij",
			empty_results: "Nema narudžbi"
		},
		report_order: { page_title: "Izvještaj narudžbi", filters: "Filtri", total: "Ukupno", orders: "Narudžbe", excel: "Excel" },
		report_offers: { page_title: "Izvještaj ponuda", available_offers: "Dostupne ponude", total: "Ukupno", empty_results: "Nema ponuda" },
		report_last_stock_update: { page_title: "Status ažuriranja zaliha pogona", subtitle: "Aktivnost zaliha po pogonu i državi, prema stvarnim redovima zaliha i vidljivim Marketplace ponudama.", factory: "Pogon", factories: "Pogoni", factories_short: "pogona", country: "Država", countries: "Države", stock_actors: "Aktivni korisnici zaliha", no_stock_actors: "Još nema aktivnosti zaliha", factory_overview: "Pregled pogona", grouped_by_country: "Grupirano po državama s aktivnošću Marketplace ponuda.", total_factories: "Ukupno", last_update: "Zadnje ažuriranje", days_since_update: "Dana od ažuriranja", days: "Dana", active_offers: "Aktivne ponude", active_articles: "Aktivni artikli", active_quantity: "Otvorena količina", estimated_value: "Procijenjena vrijednost", needs_attention: "Potrebna pažnja", needs_attention_short: "pažnja", offers_short: "ponuda", pieces_short: "kom", status_current: "Aktualno", status_stale: "Zastarjelo", status_never: "Nikad ažurirano", expand_all: "Otvori sve", collapse_all: "Zatvori sve", no_factory_data: "Nema podataka o zalihama pogona", load_failed: "Status ažuriranja zaliha pogona nije moguće učitati.", all_users_are_ok: "Svi pogoni imaju aktualne zalihe", export_to_excel: "Izvoz u Excel", never: "Nikad" },
		report_unordered_products: { page_title: "Nenaručeni proizvodi", subtitle: "Otvorene ponude rabljene robe s dostupnom količinom u usporedbi s aktivnošću narudžbi.", rows: "Redovi", laundries: "Pogoni", open_quantity: "Otvorena količina", never_ordered: "Nikad naručeno", filters: "Filtri", search_placeholder: "Traži pogon, broj artikla ili proizvod", only_never_ordered: "Samo nikad naručeno", refresh: "Osvježi", reset: "Resetiraj", stock_list: "Zalihe s malom/bez aktivnosti narudžbi", sorted_by_laundry: "Grupirano po pogonu i artiklu", total: "Ukupno", empty_results: "Nema nenaručenih zaliha", article_info: "Informacije o artiklu", ordering_signal: "Aktivnost narudžbi", has_orders: "Ima narudžbe", load_failed: "Nenaručene proizvode nije moguće učitati.", factory_code: "Pogon", article_number: "Broj artikla", product_name: "Artikl", first_upload_date: "Datum prvog unosa", current_quantity: "Otvorena količina", ordered_quantity: "Naručena količina", export_to_excel: "Izvoz u Excel" },
		imports: { page_title: "Uvozi", import_from_csv: "Uvoz iz CSV datoteke:", drop_csv_file_1: "Povucite datoteku ovdje ili", drop_csv_file_2: "kliknite za učitavanje" }
	},
	hu: {
		edit: "Szerkesztés",
		delete: "Törlés",
		cancel: "Mégse",
		save: "Mentés",
		confirm: "Megerősítés",
		add_item: "Új elem hozzáadása",
		confirm_delete: "Ez az elem véglegesen törlődik. Folytatja?",
		warning_title: "Figyelmeztetés",
		all: "Összes",
		filter: "Szűrés",
		filters: "Szűrők",
		reset: "Visszaállítás",
		operations: "Műveletek",
		used: "használt",
		new: "új",
		accepted: "elfogadva",
		pending: "függőben",
		rejected: "elutasítva",
		login: {
			title: "Bejelentkezés",
			subtitle: "Bejelentkezés a Marketplace-be",
			marketplace_title: "Salesianer Marketplace",
			microsoft_subtitle: "Jelentkezzen be Salesianer Microsoft-fiókjával",
			microsoft_button: "Bejelentkezés Microsofttal",
			sso_unavailable: "A Microsoft bejelentkezés átmenetileg nem érhető el.",
			sso_not_configured: "Az Azure SSO még nincs konfigurálva.",
			no_access: "Még nincs Marketplace hozzáférése?",
			request_access: "Hozzáférés kérése"
		},
		request_access: {
			request_title: "Hozzáférés kérése",
			sent_title: "Kérés elküldve",
			request_subtitle: "Írja meg, hol van szüksége Marketplace hozzáférésre.",
			sent_subtitle: "Valaki a lehető leghamarabb válaszol.",
			country: "Ország / régió",
			country_placeholder: "Válasszon országot / régiót",
			factory: "Üzem",
			factory_placeholder: "Válasszon üzemet",
			message: "Üzenet",
			message_placeholder: "Szerepkör, üzem vagy üzleti indok",
			back: "Vissza",
			submit: "Hozzáférés kérése",
			success_message: "A kérést elküldtük a felelős jóváhagyóknak.",
			back_to_login: "Vissza a bejelentkezéshez",
			send_failed: "A kérést nem sikerült elküldeni."
		},
		menu: {
			last_stock_update: "Üzemi készletfrissítések",
			log_out: "Kijelentkezés",
			dashboard: "Irányítópult",
			my_stocks: "Saját készletek",
			my_orders: "Saját rendelések",
			administration: "Adminisztráció",
			users: "Felhasználók",
			power_user_allocation: "Power User hozzárendelés",
			factories: "Üzemek",
			right_groups: "Jogosultsági csoportok",
			product_categories: "Termékkategóriák",
			products: "Termékek",
			reports: "Riportok",
			report_activity: "Rendelések és ajánlatok",
			report_stock_control: "Készletellenőrzés",
			unordered_products: "Nem rendelt cikkek",
			orders: "Rendelések",
			offers: "Ajánlatok",
			lazy_users: "Inaktív felhasználók",
			settings: "Globális beállítások",
			change_password: "Jelszó módosítása",
			imports: "Importok",
			lang: "Nyelv",
			active_factory: "Üzem",
			primary_factory: "Elsődleges",
			active_factory_changed: "Aktív üzem módosítva",
			my_profile: "Profilom"
		},
		users: {
			page_title: "Felhasználók",
			name: "Név",
			email: "E-mail",
			factory_country: "Üzem országa",
			factory_code: "Üzemkód",
			filters: "Szűrők",
			search_placeholder: "Név vagy e-mail keresése",
			sso_status: "SSO állapot",
			dialog_title: "Felhasználói adatok",
			user_group: "Felhasználói csoport",
			user_factory: "Felhasználó üzeme",
			assigned_plants: "Hozzárendelt üzemek",
			primary_factory: "Elsődleges",
			additional_factories: "Hozzárendelt üzemek",
			load_failed: "A felhasználók betöltése nem sikerült."
		},
		power_user_allocation: {
			page_title: "Power User hozzárendelés",
			subtitle: "Ország- és üzemlefedettség a Marketplace hozzáférések jóváhagyásához.",
			refresh: "Frissítés",
			countries: "Országok",
			factories: "Üzemek",
			power_users: "Power Userök",
			system_admins: "Rendszergazdák",
			uncovered_plants: "Lefedetlen üzemek",
			no_power_users: "Nincs hozzárendelt Power User",
			no_uncovered: "Minden üzem lefedve",
			gaps: "Hiányok"
		},
		factories: { page_title: "Üzemek", country: "Ország", code: "Üzemkód", address: "Cím", name: "Név", search_placeholder: "Ország, kód, e-mail vagy cím keresése" },
		products: { page_title: "Termékek", name: "Név", category: "Kategória", description: "Leírás", article_number: "Cikkszám", filters: "Szűrők", search_placeholder: "Cikk, név vagy leírás keresése", status: "Állapot", approved: "Jóváhagyva", pending: "Függőben", total_products: "Termékek", total: "Összesen", list_title: "Terméklista", marketplace_price: "Marketplace ár", missing_price: "Hiányzó ár" },
		categories: { page_title: "Termékkategóriák", name: "Név", status: "Állapot", approved: "Jóváhagyva", pending: "Függőben", total: "Összesen", list_title: "Kategórialista" },
		mystocks: { page_title: "Saját készletek", total_products: "Termékek", with_used_quantity: "készleten", search_article: "Cikkszám keresése", stock_list: "Készletlista", sorted_by_activity: "Utolsó aktivitás szerint rendezve", total: "Összesen", filters: "Szűrők", import_from_csv: "Import CSV fájlból:", article_number: "Cikkszám", used_in_stock: "Használt (menny.)", price: "Ár" },
		dashboard: { page_title: "Irányítópult", available_offers: "Ajánlatok", stock_offers: "Készletajánlatok", sorted_by_id: "Legújabb ID szerint rendezve", total: "Összesen", factory_code: "Üzemkód", seller_name: "Eladó", created_date: "Létrehozva", article_info: "Cikkinformáció", quantity: "Mennyiség", price: "Ár", order: "Rendelés", operations: "Műveletek", article_code: "Cikkszám:", search_article: "Cikkszám keresése", quantity_range: "Mennyiségtartomány:", category: "Kategória", preview_seller: "Megtekintés eladóként", preview_seller_placeholder: "Eladó kiválasztása" },
		myorders: { page_title: "Saját rendelések", total_orders: "Rendelések", orders: "Rendelések", sorted_by_newest: "Legújabb kérés szerint rendezve", total: "Összesen", filter_status: "Állapot", factory_code: "Üzemkód", seller_name: "Eladó", buyer_name: "Vevő", article_info: "Cikkinformáció", quantity: "Mennyiség", price: "Ár", operations: "Műveletek", approve: "Jóváhagyás", reject: "Elutasítás" },
		report_order: { page_title: "Rendelési riport", filters: "Szűrők", total: "Összesen", orders: "Rendelések", excel: "Excel" },
		report_offers: { page_title: "Ajánlatriport", available_offers: "Elérhető ajánlatok", total: "Összesen", empty_results: "Nincs ajánlat" },
		report_last_stock_update: { page_title: "Üzemi készletfrissítési állapot", subtitle: "Üzemi készletaktivitás országonként, tényleges készletsorok és látható Marketplace ajánlatok alapján.", factory: "Üzem", factories: "Üzemek", factories_short: "üzem", country: "Ország", countries: "Országok", stock_actors: "Aktív készletfelhasználók", no_stock_actors: "Még nincs készletaktivitás", factory_overview: "Üzemi áttekintés", grouped_by_country: "Ország szerint csoportosítva, aktuális Marketplace ajánlatokkal.", total_factories: "Összesen", last_update: "Utolsó frissítés", days_since_update: "Napok a frissítés óta", days: "Nap", active_offers: "Aktív ajánlatok", active_articles: "Aktív cikkek", active_quantity: "Nyitott mennyiség", estimated_value: "Becsült érték", needs_attention: "Figyelmet igényel", needs_attention_short: "figyelem", offers_short: "ajánlat", pieces_short: "db", status_current: "Aktuális", status_stale: "Elavult", status_never: "Soha nem frissített", expand_all: "Mindet megnyit", collapse_all: "Mindet bezár", no_factory_data: "Nincs üzemi készletadat", load_failed: "Az üzemi készletfrissítési állapot nem tölthető be.", all_users_are_ok: "Minden üzem készlete naprakész", export_to_excel: "Export Excelbe", never: "Soha" },
		report_unordered_products: { page_title: "Nem rendelt termékek", subtitle: "Nyitott használtkészlet-ajánlatok elérhető mennyiséggel, rendelési aktivitással összevetve.", rows: "Sorok", laundries: "Üzemek", open_quantity: "Nyitott mennyiség", never_ordered: "Soha nem rendelt", filters: "Szűrők", search_placeholder: "Üzem, cikkszám vagy termék keresése", only_never_ordered: "Csak soha nem rendelt", refresh: "Frissítés", reset: "Visszaállítás", stock_list: "Készletek alacsony/nincs rendelési aktivitással", sorted_by_laundry: "Üzem és cikk szerint csoportosítva", total: "Összesen", empty_results: "Nincs nem rendelt készlet", article_info: "Cikkinformáció", ordering_signal: "Rendelési aktivitás", has_orders: "Van rendelés", load_failed: "A nem rendelt termékek betöltése nem sikerült.", factory_code: "Üzem", article_number: "Cikkszám", product_name: "Cikk", first_upload_date: "Első feltöltés dátuma", current_quantity: "Nyitott mennyiség", ordered_quantity: "Rendelt mennyiség", export_to_excel: "Export Excelbe" },
		imports: { page_title: "Importok", import_from_csv: "Import CSV fájlból:", drop_csv_file_1: "Húzza ide a fájlt vagy", drop_csv_file_2: "kattintson a feltöltéshez" }
	},
	pl: {
		edit: "Edytuj",
		delete: "Usuń",
		cancel: "Anuluj",
		save: "Zapisz",
		confirm: "Potwierdź",
		add_item: "Dodaj pozycję",
		confirm_delete: "Ta pozycja zostanie trwale usunięta. Kontynuować?",
		warning_title: "Ostrzeżenie",
		all: "Wszystkie",
		filter: "Filtruj",
		filters: "Filtry",
		reset: "Resetuj",
		operations: "Akcje",
		used: "używane",
		new: "nowe",
		accepted: "zaakceptowane",
		pending: "oczekujące",
		rejected: "odrzucone",
		login: { title: "Logowanie", marketplace_title: "Salesianer Marketplace", microsoft_subtitle: "Zaloguj się kontem Microsoft Salesianer", microsoft_button: "Zaloguj przez Microsoft", sso_unavailable: "Logowanie Microsoft jest tymczasowo niedostępne.", sso_not_configured: "Azure SSO nie jest jeszcze skonfigurowane.", no_access: "Nie masz jeszcze dostępu do Marketplace?", request_access: "Poproś o dostęp" },
		request_access: { request_title: "Poproś o dostęp", sent_title: "Wniosek wysłany", request_subtitle: "Napisz, gdzie potrzebujesz dostępu do Marketplace.", sent_subtitle: "Ktoś odpowie tak szybko, jak to możliwe.", country: "Kraj / region", country_placeholder: "Wybierz kraj / region", factory: "Zakład", factory_placeholder: "Wybierz zakład", message: "Wiadomość", message_placeholder: "Rola, zakład lub uzasadnienie biznesowe", back: "Wstecz", submit: "Poproś o dostęp", success_message: "Wniosek został wysłany do odpowiedzialnych osób zatwierdzających.", back_to_login: "Powrót do logowania", send_failed: "Nie można wysłać wniosku." },
		menu: { last_stock_update: "Aktualizacje stanów zakładów", log_out: "Wyloguj", dashboard: "Panel", my_stocks: "Moje stany", my_orders: "Moje zamówienia", administration: "Administracja", users: "Użytkownicy", power_user_allocation: "Przypisanie Power Userów", factories: "Zakłady", right_groups: "Grupy uprawnień", product_categories: "Kategorie produktów", products: "Produkty", reports: "Raporty", report_activity: "Zamówienia i oferty", report_stock_control: "Kontrola stanów", unordered_products: "Nie zamówione artykuły", orders: "Zamówienia", offers: "Oferty", imports: "Importy", lang: "Język", active_factory: "Zakład", primary_factory: "Główny", active_factory_changed: "Aktywny zakład zmieniony", my_profile: "Mój profil" },
		users: { page_title: "Użytkownicy", name: "Nazwa", email: "E-mail", factory_country: "Kraj zakładu", factory_code: "Kod zakładu", filters: "Filtry", search_placeholder: "Szukaj nazwy lub e-maila", sso_status: "Status SSO", dialog_title: "Dane użytkownika", user_group: "Grupa użytkownika", user_factory: "Zakład użytkownika", assigned_plants: "Przypisane zakłady", primary_factory: "Główny", load_failed: "Nie można załadować użytkowników." },
		power_user_allocation: { page_title: "Przypisanie Power Userów", subtitle: "Pokrycie krajów i zakładów dla zatwierdzania dostępu Marketplace.", refresh: "Odśwież", countries: "Kraje", factories: "Zakłady", power_users: "Power Userzy", system_admins: "Administratorzy systemu", uncovered_plants: "Niepokryte zakłady", no_power_users: "Brak przypisanego Power Usera", no_uncovered: "Wszystkie zakłady pokryte", gaps: "Luki" },
		factories: { page_title: "Zakłady", country: "Kraj", code: "Kod zakładu", address: "Adres", name: "Nazwa", search_placeholder: "Szukaj kraju, kodu, e-maila lub adresu" },
		products: { page_title: "Produkty", name: "Nazwa", category: "Kategoria", description: "Opis", article_number: "Numer artykułu", filters: "Filtry", search_placeholder: "Szukaj artykułu, nazwy lub opisu", status: "Status", approved: "Zatwierdzone", pending: "Oczekujące", total_products: "Produkty", total: "Razem", list_title: "Lista produktów", marketplace_price: "Cena Marketplace", missing_price: "Brak ceny" },
		categories: { page_title: "Kategorie produktów", name: "Nazwa", status: "Status", approved: "Zatwierdzone", pending: "Oczekujące", total: "Razem", list_title: "Lista kategorii" },
		mystocks: { page_title: "Moje stany", total_products: "Produkty", with_used_quantity: "ze stanem", search_article: "Szukaj kodu artykułu", stock_list: "Lista stanów", sorted_by_activity: "Sortowane według ostatniej aktywności", total: "Razem", filters: "Filtry", import_from_csv: "Import z pliku CSV:", article_number: "Numer artykułu", used_in_stock: "Używane (ilość)", price: "Cena" },
		dashboard: { page_title: "Panel", available_offers: "Oferty", stock_offers: "Oferty magazynowe", sorted_by_id: "Sortowane według najnowszego ID", total: "Razem", factory_code: "Kod zakładu", seller_name: "Sprzedawca", created_date: "Utworzono", article_info: "Informacje o artykule", quantity: "Ilość", price: "Cena", order: "Zamów", operations: "Akcje", article_code: "Kod artykułu:", search_article: "Szukaj kodu artykułu", quantity_range: "Zakres ilości:", category: "Kategoria", preview_seller: "Podgląd jako sprzedawca", preview_seller_placeholder: "Wybierz sprzedawcę" },
		myorders: { page_title: "Moje zamówienia", total_orders: "Zamówienia", orders: "Zamówienia", sorted_by_newest: "Sortowane według najnowszego wniosku", total: "Razem", filter_status: "Status", factory_code: "Kod zakładu", seller_name: "Sprzedawca", buyer_name: "Kupujący", article_info: "Informacje o artykule", quantity: "Ilość", price: "Cena", operations: "Akcje", approve: "Zatwierdź", reject: "Odrzuć" },
		report_order: { page_title: "Raport zamówień", filters: "Filtry", total: "Razem", orders: "Zamówienia", excel: "Excel" },
		report_offers: { page_title: "Raport ofert", available_offers: "Dostępne oferty", total: "Razem", empty_results: "Brak ofert" },
		report_last_stock_update: { page_title: "Status aktualizacji stanów zakładów", subtitle: "Aktywność stanów według zakładu i kraju, na podstawie rzeczywistych wpisów stanów i widocznych ofert Marketplace.", factory: "Zakład", factories: "Zakłady", factories_short: "zakładów", country: "Kraj", countries: "Kraje", stock_actors: "Aktywni użytkownicy stanów", no_stock_actors: "Brak aktywności stanów", factory_overview: "Przegląd zakładów", grouped_by_country: "Pogrupowane według kraju z aktywnością ofert Marketplace.", total_factories: "Razem", last_update: "Ostatnia aktualizacja", days_since_update: "Dni od aktualizacji", days: "Dni", active_offers: "Aktywne oferty", active_articles: "Aktywne artykuły", active_quantity: "Otwarta ilość", estimated_value: "Szacowana wartość", needs_attention: "Wymaga uwagi", needs_attention_short: "uwaga", offers_short: "ofert", pieces_short: "szt.", status_current: "Aktualne", status_stale: "Nieaktualne", status_never: "Nigdy nie aktualizowano", expand_all: "Rozwiń wszystko", collapse_all: "Zwiń wszystko", no_factory_data: "Brak danych stanów zakładów", load_failed: "Nie można załadować statusu aktualizacji stanów zakładów.", all_users_are_ok: "Wszystkie zakłady mają aktualne stany", export_to_excel: "Eksport do Excel", never: "Nigdy" },
		report_unordered_products: { page_title: "Nie zamówione produkty", subtitle: "Otwarte oferty używanych stanów z dostępną ilością w porównaniu z aktywnością zamówień.", rows: "Wiersze", laundries: "Zakłady", open_quantity: "Otwarta ilość", never_ordered: "Nigdy nie zamówione", filters: "Filtry", search_placeholder: "Szukaj zakładu, numeru artykułu lub produktu", only_never_ordered: "Tylko nigdy nie zamówione", refresh: "Odśwież", reset: "Resetuj", stock_list: "Stany z małą/bez aktywności zamówień", sorted_by_laundry: "Pogrupowane według zakładu i artykułu", total: "Razem", empty_results: "Brak niezamówionych stanów", article_info: "Informacje o artykule", ordering_signal: "Aktywność zamówień", has_orders: "Ma zamówienia", load_failed: "Nie można załadować niezamówionych produktów.", factory_code: "Zakład", article_number: "Numer artykułu", product_name: "Artykuł", first_upload_date: "Data pierwszego przesłania", current_quantity: "Otwarta ilość", ordered_quantity: "Zamówiona ilość", export_to_excel: "Eksport do Excel" },
		imports: { page_title: "Importy", import_from_csv: "Import z pliku CSV:", drop_csv_file_1: "Przeciągnij plik tutaj lub", drop_csv_file_2: "kliknij, aby przesłać" }
	},
	sk: {
		edit: "Upraviť",
		delete: "Vymazať",
		cancel: "Zrušiť",
		save: "Uložiť",
		confirm: "Potvrdiť",
		add_item: "Pridať položku",
		confirm_delete: "Táto položka bude natrvalo vymazaná. Pokračovať?",
		warning_title: "Upozornenie",
		all: "Všetko",
		filter: "Filtrovať",
		filters: "Filtre",
		reset: "Resetovať",
		operations: "Akcie",
		used: "použité",
		new: "nové",
		accepted: "prijaté",
		pending: "čaká",
		rejected: "zamietnuté",
		login: { title: "Prihlásenie", marketplace_title: "Salesianer Marketplace", microsoft_subtitle: "Prihláste sa svojím účtom Microsoft Salesianer", microsoft_button: "Prihlásiť cez Microsoft", sso_unavailable: "Prihlásenie cez Microsoft je dočasne nedostupné.", sso_not_configured: "Azure SSO ešte nie je nakonfigurované.", no_access: "Ešte nemáte prístup do Marketplace?", request_access: "Požiadať o prístup" },
		request_access: { request_title: "Požiadať o prístup", sent_title: "Žiadosť odoslaná", request_subtitle: "Napíšte nám, kde potrebujete prístup do Marketplace.", sent_subtitle: "Niekto sa vám ozve čo najskôr.", country: "Krajina / región", country_placeholder: "Vyberte krajinu / región", factory: "Prevádzka", factory_placeholder: "Vyberte prevádzku", message: "Správa", message_placeholder: "Rola, prevádzka alebo obchodný dôvod", back: "Späť", submit: "Požiadať o prístup", success_message: "Vaša žiadosť bola odoslaná zodpovedným schvaľovateľom.", back_to_login: "Späť na prihlásenie", send_failed: "Žiadosť sa nepodarilo odoslať." },
		menu: { last_stock_update: "Aktualizácie skladov prevádzok", log_out: "Odhlásiť", dashboard: "Dashboard", my_stocks: "Moje sklady", my_orders: "Moje objednávky", administration: "Administrácia", users: "Používatelia", power_user_allocation: "Priradenie Power Userov", factories: "Prevádzky", right_groups: "Skupiny oprávnení", product_categories: "Kategórie produktov", products: "Produkty", reports: "Reporty", report_activity: "Objednávky a ponuky", report_stock_control: "Kontrola zásob", unordered_products: "Neobjednané položky", orders: "Objednávky", offers: "Ponuky", imports: "Importy", lang: "Jazyk", active_factory: "Prevádzka", primary_factory: "Primárna", active_factory_changed: "Aktívna prevádzka zmenená", my_profile: "Môj profil" },
		users: { page_title: "Používatelia", name: "Meno", email: "E-mail", factory_country: "Krajina prevádzky", factory_code: "Kód prevádzky", filters: "Filtre", search_placeholder: "Hľadať meno alebo e-mail", sso_status: "SSO stav", dialog_title: "Údaje používateľa", user_group: "Skupina používateľov", user_factory: "Prevádzka používateľa", assigned_plants: "Priradené prevádzky", primary_factory: "Primárna", load_failed: "Používateľov sa nepodarilo načítať." },
		power_user_allocation: { page_title: "Priradenie Power Userov", subtitle: "Pokrytie krajín a prevádzok pre schvaľovanie prístupu do Marketplace.", refresh: "Obnoviť", countries: "Krajiny", factories: "Prevádzky", power_users: "Power Useri", system_admins: "Systémoví administrátori", uncovered_plants: "Nepokryté prevádzky", no_power_users: "Nie je priradený žiadny Power User", no_uncovered: "Všetky prevádzky sú pokryté", gaps: "Medzery" },
		factories: { page_title: "Prevádzky", country: "Krajina", code: "Kód prevádzky", address: "Adresa", name: "Názov", search_placeholder: "Hľadať krajinu, kód, e-mail alebo adresu" },
		products: { page_title: "Produkty", name: "Názov", category: "Kategória", description: "Popis", article_number: "Číslo artikla", filters: "Filtre", search_placeholder: "Hľadať artikel, názov alebo popis", status: "Stav", approved: "Schválené", pending: "Čaká", total_products: "Produkty", total: "Spolu", list_title: "Zoznam produktov", marketplace_price: "Cena Marketplace", missing_price: "Chýba cena" },
		categories: { page_title: "Kategórie produktov", name: "Názov", status: "Stav", approved: "Schválené", pending: "Čaká", total: "Spolu", list_title: "Zoznam kategórií" },
		mystocks: { page_title: "Moje sklady", total_products: "Produkty", with_used_quantity: "so skladom", search_article: "Hľadať kód artikla", stock_list: "Zoznam skladov", sorted_by_activity: "Zoradené podľa poslednej aktivity", total: "Spolu", filters: "Filtre", import_from_csv: "Import zo súboru CSV:", article_number: "Číslo artikla", used_in_stock: "Použité (množ.)", price: "Cena" },
		dashboard: { page_title: "Dashboard", available_offers: "Ponuky", stock_offers: "Skladové ponuky", sorted_by_id: "Zoradené podľa najnovšieho ID", total: "Spolu", factory_code: "Kód prevádzky", seller_name: "Predajca", created_date: "Vytvorené", article_info: "Informácie o artikli", quantity: "Množstvo", price: "Cena", order: "Objednať", operations: "Akcie", article_code: "Kód artikla:", search_article: "Hľadať kód artikla", quantity_range: "Rozsah množstva:", category: "Kategória", preview_seller: "Zobraziť ako predajca", preview_seller_placeholder: "Vyberte predajcu" },
		myorders: { page_title: "Moje objednávky", total_orders: "Objednávky", orders: "Objednávky", sorted_by_newest: "Zoradené podľa najnovšej žiadosti", total: "Spolu", filter_status: "Stav", factory_code: "Kód prevádzky", seller_name: "Predajca", buyer_name: "Kupujúci", article_info: "Informácie o artikli", quantity: "Množstvo", price: "Cena", operations: "Akcie", approve: "Schváliť", reject: "Zamietnuť" },
		report_order: { page_title: "Report objednávok", filters: "Filtre", total: "Spolu", orders: "Objednávky", excel: "Excel" },
		report_offers: { page_title: "Report ponúk", available_offers: "Dostupné ponuky", total: "Spolu", empty_results: "Žiadne ponuky" },
		report_last_stock_update: { page_title: "Stav aktualizácie skladov prevádzok", subtitle: "Skladová aktivita podľa prevádzky a krajiny, podľa skutočných skladových riadkov a viditeľných ponúk Marketplace.", factory: "Prevádzka", factories: "Prevádzky", factories_short: "prevádzok", country: "Krajina", countries: "Krajiny", stock_actors: "Aktívni skladoví používatelia", no_stock_actors: "Zatiaľ žiadna skladová aktivita", factory_overview: "Prehľad prevádzok", grouped_by_country: "Zoskupené podľa krajiny s aktivitou ponúk Marketplace.", total_factories: "Spolu", last_update: "Posledná aktualizácia", days_since_update: "Dni od aktualizácie", days: "Dni", active_offers: "Aktívne ponuky", active_articles: "Aktívne artikle", active_quantity: "Otvorené množstvo", estimated_value: "Odhadovaná hodnota", needs_attention: "Vyžaduje pozornosť", needs_attention_short: "pozornosť", offers_short: "ponúk", pieces_short: "ks", status_current: "Aktuálne", status_stale: "Zastaralé", status_never: "Nikdy neaktualizované", expand_all: "Rozbaliť všetko", collapse_all: "Zbaliť všetko", no_factory_data: "Nenašli sa žiadne skladové údaje prevádzok", load_failed: "Stav aktualizácie skladov prevádzok sa nepodarilo načítať.", all_users_are_ok: "Všetky prevádzky majú aktuálne zásoby", export_to_excel: "Export do Excelu", never: "Nikdy" },
		report_unordered_products: { page_title: "Neobjednané produkty", subtitle: "Otvorené ponuky použitého skladu s dostupným množstvom v porovnaní s aktivitou objednávok.", rows: "Riadky", laundries: "Prevádzky", open_quantity: "Otvorené množstvo", never_ordered: "Nikdy neobjednané", filters: "Filtre", search_placeholder: "Hľadať prevádzku, číslo artikla alebo produkt", only_never_ordered: "Iba nikdy neobjednané", refresh: "Obnoviť", reset: "Resetovať", stock_list: "Sklady s nízkou/žiadnou aktivitou objednávok", sorted_by_laundry: "Zoskupené podľa prevádzky a artikla", total: "Spolu", empty_results: "Nenašli sa žiadne neobjednané zásoby", article_info: "Informácie o artikli", ordering_signal: "Aktivita objednávok", has_orders: "Má objednávky", load_failed: "Neobjednané produkty sa nepodarilo načítať.", factory_code: "Prevádzka", article_number: "Číslo artikla", product_name: "Artikel", first_upload_date: "Dátum prvého nahrania", current_quantity: "Otvorené množstvo", ordered_quantity: "Objednané množstvo", export_to_excel: "Export do Excelu" },
		imports: { page_title: "Importy", import_from_csv: "Import zo súboru CSV:", drop_csv_file_1: "Presuňte súbor sem alebo", drop_csv_file_2: "kliknite pre nahratie" }
	},
	sl: {
		edit: "Uredi",
		delete: "Izbriši",
		cancel: "Prekliči",
		save: "Shrani",
		confirm: "Potrdi",
		add_item: "Dodaj postavko",
		confirm_delete: "Ta postavka bo trajno izbrisana. Nadaljujem?",
		warning_title: "Opozorilo",
		all: "Vse",
		filter: "Filtriraj",
		filters: "Filtri",
		reset: "Ponastavi",
		operations: "Dejanja",
		used: "rabljeno",
		new: "novo",
		accepted: "sprejeto",
		pending: "v čakanju",
		rejected: "zavrnjeno",
		login: { title: "Prijava", marketplace_title: "Salesianer Marketplace", microsoft_subtitle: "Prijavite se s svojim Salesianer Microsoft računom", microsoft_button: "Prijava z Microsoftom", sso_unavailable: "Microsoft prijava trenutno ni na voljo.", sso_not_configured: "Azure SSO še ni konfiguriran.", no_access: "Še nimate dostopa do Marketplace?", request_access: "Zahtevaj dostop" },
		request_access: { request_title: "Zahtevaj dostop", sent_title: "Zahteva poslana", request_subtitle: "Povejte nam, kje potrebujete dostop do Marketplace.", sent_subtitle: "Nekdo bo odgovoril čim prej.", country: "Država / regija", country_placeholder: "Izberite državo / regijo", factory: "Obrat", factory_placeholder: "Izberite obrat", message: "Sporočilo", message_placeholder: "Vloga, obrat ali poslovni razlog", back: "Nazaj", submit: "Zahtevaj dostop", success_message: "Vaša zahteva je bila poslana odgovornim potrjevalcem.", back_to_login: "Nazaj na prijavo", send_failed: "Zahteve ni bilo mogoče poslati." },
		menu: { last_stock_update: "Posodobitve zalog obratov", log_out: "Odjava", dashboard: "Nadzorna plošča", my_stocks: "Moje zaloge", my_orders: "Moja naročila", administration: "Administracija", users: "Uporabniki", power_user_allocation: "Dodelitev Power Userjev", factories: "Obrati", right_groups: "Skupine pravic", product_categories: "Kategorije izdelkov", products: "Izdelki", reports: "Poročila", report_activity: "Naročila in ponudbe", report_stock_control: "Nadzor zalog", unordered_products: "Nenaročeni artikli", orders: "Naročila", offers: "Ponudbe", imports: "Uvozi", lang: "Jezik", active_factory: "Obrat", primary_factory: "Primarni", active_factory_changed: "Aktivni obrat spremenjen", my_profile: "Moj profil" },
		users: { page_title: "Uporabniki", name: "Ime", email: "E-pošta", factory_country: "Država obrata", factory_code: "Koda obrata", filters: "Filtri", search_placeholder: "Išči ime ali e-pošto", sso_status: "SSO stanje", dialog_title: "Podatki uporabnika", user_group: "Skupina uporabnika", user_factory: "Obrat uporabnika", assigned_plants: "Dodeljeni obrati", primary_factory: "Primarni", load_failed: "Uporabnikov ni bilo mogoče naložiti." },
		power_user_allocation: { page_title: "Dodelitev Power Userjev", subtitle: "Pokritost držav in obratov za odobritve dostopa Marketplace.", refresh: "Osveži", countries: "Države", factories: "Obrati", power_users: "Power Userji", system_admins: "Sistemski administratorji", uncovered_plants: "Nepokriti obrati", no_power_users: "Ni dodeljenega Power Userja", no_uncovered: "Vsi obrati so pokriti", gaps: "Vrzeli" },
		factories: { page_title: "Obrati", country: "Država", code: "Koda obrata", address: "Naslov", name: "Naziv", search_placeholder: "Išči državo, kodo, e-pošto ali naslov" },
		products: { page_title: "Izdelki", name: "Naziv", category: "Kategorija", description: "Opis", article_number: "Številka artikla", filters: "Filtri", search_placeholder: "Išči artikel, naziv ali opis", status: "Stanje", approved: "Odobreno", pending: "V čakanju", total_products: "Izdelki", total: "Skupaj", list_title: "Seznam izdelkov", marketplace_price: "Cena Marketplace", missing_price: "Manjka cena" },
		categories: { page_title: "Kategorije izdelkov", name: "Naziv", status: "Stanje", approved: "Odobreno", pending: "V čakanju", total: "Skupaj", list_title: "Seznam kategorij" },
		mystocks: { page_title: "Moje zaloge", total_products: "Izdelki", with_used_quantity: "z zalogo", search_article: "Išči kodo artikla", stock_list: "Seznam zalog", sorted_by_activity: "Razvrščeno po zadnji aktivnosti", total: "Skupaj", filters: "Filtri", import_from_csv: "Uvoz iz CSV datoteke:", article_number: "Številka artikla", used_in_stock: "Rabljeno (kol.)", price: "Cena" },
		dashboard: { page_title: "Nadzorna plošča", available_offers: "Ponudbe", stock_offers: "Ponudbe zalog", sorted_by_id: "Razvrščeno po najnovejšem ID", total: "Skupaj", factory_code: "Koda obrata", seller_name: "Prodajalec", created_date: "Ustvarjeno", article_info: "Informacije o artiklu", quantity: "Količina", price: "Cena", order: "Naroči", operations: "Dejanja", article_code: "Koda artikla:", search_article: "Išči kodo artikla", quantity_range: "Razpon količine:", category: "Kategorija", preview_seller: "Prikaži kot prodajalec", preview_seller_placeholder: "Izberite prodajalca" },
		myorders: { page_title: "Moja naročila", total_orders: "Naročila", orders: "Naročila", sorted_by_newest: "Razvrščeno po najnovejši zahtevi", total: "Skupaj", filter_status: "Stanje", factory_code: "Koda obrata", seller_name: "Prodajalec", buyer_name: "Kupec", article_info: "Informacije o artiklu", quantity: "Količina", price: "Cena", operations: "Dejanja", approve: "Odobri", reject: "Zavrni" },
		report_order: { page_title: "Poročilo naročil", filters: "Filtri", total: "Skupaj", orders: "Naročila", excel: "Excel" },
		report_offers: { page_title: "Poročilo ponudb", available_offers: "Razpoložljive ponudbe", total: "Skupaj", empty_results: "Ni ponudb" },
		report_last_stock_update: { page_title: "Stanje posodobitev zalog obratov", subtitle: "Aktivnost zalog po obratu in državi, na podlagi dejanskih vrstic zalog in vidnih ponudb Marketplace.", factory: "Obrat", factories: "Obrati", factories_short: "obratov", country: "Država", countries: "Države", stock_actors: "Aktivni uporabniki zalog", no_stock_actors: "Še ni aktivnosti zalog", factory_overview: "Pregled obratov", grouped_by_country: "Združeno po državah z aktivnostjo ponudb Marketplace.", total_factories: "Skupaj", last_update: "Zadnja posodobitev", days_since_update: "Dni od posodobitve", days: "Dni", active_offers: "Aktivne ponudbe", active_articles: "Aktivni artikli", active_quantity: "Odprta količina", estimated_value: "Ocenjena vrednost", needs_attention: "Potrebuje pozornost", needs_attention_short: "pozornost", offers_short: "ponudb", pieces_short: "kos", status_current: "Aktualno", status_stale: "Zastarelo", status_never: "Nikoli posodobljeno", expand_all: "Razširi vse", collapse_all: "Strni vse", no_factory_data: "Ni podatkov o zalogah obratov", load_failed: "Stanja posodobitev zalog obratov ni bilo mogoče naložiti.", all_users_are_ok: "Vsi obrati imajo aktualne zaloge", export_to_excel: "Izvoz v Excel", never: "Nikoli" },
		report_unordered_products: { page_title: "Nenaročeni izdelki", subtitle: "Odprte ponudbe rabljenih zalog z razpoložljivo količino v primerjavi z aktivnostjo naročil.", rows: "Vrstice", laundries: "Obrati", open_quantity: "Odprta količina", never_ordered: "Nikoli naročeno", filters: "Filtri", search_placeholder: "Išči obrat, številko artikla ali izdelek", only_never_ordered: "Samo nikoli naročeno", refresh: "Osveži", reset: "Ponastavi", stock_list: "Zaloge z nizko/brez aktivnosti naročil", sorted_by_laundry: "Združeno po obratu in artiklu", total: "Skupaj", empty_results: "Ni nenaročenih zalog", article_info: "Informacije o artiklu", ordering_signal: "Aktivnost naročil", has_orders: "Ima naročila", load_failed: "Nenaročenih izdelkov ni bilo mogoče naložiti.", factory_code: "Obrat", article_number: "Številka artikla", product_name: "Artikel", first_upload_date: "Datum prvega nalaganja", current_quantity: "Odprta količina", ordered_quantity: "Naročena količina", export_to_excel: "Izvoz v Excel" },
		imports: { page_title: "Uvozi", import_from_csv: "Uvoz iz CSV datoteke:", drop_csv_file_1: "Povlecite datoteko sem ali", drop_csv_file_2: "kliknite za nalaganje" }
	},
	sr: {
		edit: "Uredi",
		delete: "Obriši",
		cancel: "Otkaži",
		save: "Sačuvaj",
		confirm: "Potvrdi",
		add_item: "Dodaj stavku",
		confirm_delete: "Ova stavka će biti trajno obrisana. Nastaviti?",
		warning_title: "Upozorenje",
		all: "Sve",
		filter: "Filtriraj",
		filters: "Filteri",
		reset: "Resetuj",
		operations: "Radnje",
		used: "polovno",
		new: "novo",
		accepted: "prihvaćeno",
		pending: "na čekanju",
		rejected: "odbijeno",
		login: { title: "Prijava", marketplace_title: "Salesianer Marketplace", microsoft_subtitle: "Prijavite se svojim Salesianer Microsoft nalogom", microsoft_button: "Prijava preko Microsofta", sso_unavailable: "Microsoft prijava trenutno nije dostupna.", sso_not_configured: "Azure SSO još nije konfigurisan.", no_access: "Još nemate pristup Marketplaceu?", request_access: "Zatraži pristup" },
		request_access: { request_title: "Zatraži pristup", sent_title: "Zahtev poslat", request_subtitle: "Recite nam gde vam je potreban pristup Marketplaceu.", sent_subtitle: "Neko će odgovoriti što je pre moguće.", country: "Država / region", country_placeholder: "Izaberite državu / region", factory: "Pogon", factory_placeholder: "Izaberite pogon", message: "Poruka", message_placeholder: "Uloga, pogon ili poslovni razlog", back: "Nazad", submit: "Zatraži pristup", success_message: "Vaš zahtev je poslat odgovornim odobravaocima.", back_to_login: "Nazad na prijavu", send_failed: "Zahtev nije moguće poslati." },
		menu: { last_stock_update: "Ažuriranja zaliha pogona", log_out: "Odjava", dashboard: "Kontrolna tabla", my_stocks: "Moje zalihe", my_orders: "Moje narudžbine", administration: "Administracija", users: "Korisnici", power_user_allocation: "Dodela Power Usera", factories: "Pogoni", right_groups: "Grupe prava", product_categories: "Kategorije proizvoda", products: "Proizvodi", reports: "Izveštaji", report_activity: "Narudžbine i ponude", report_stock_control: "Kontrola zaliha", unordered_products: "Nenaručeni artikli", orders: "Narudžbine", offers: "Ponude", imports: "Uvozi", lang: "Jezik", active_factory: "Pogon", primary_factory: "Primarni", active_factory_changed: "Aktivni pogon promenjen", my_profile: "Moj profil" },
		users: { page_title: "Korisnici", name: "Ime", email: "E-mail", factory_country: "Država pogona", factory_code: "Kod pogona", filters: "Filteri", search_placeholder: "Traži ime ili e-mail", sso_status: "SSO status", dialog_title: "Podaci korisnika", user_group: "Korisnička grupa", user_factory: "Pogon korisnika", assigned_plants: "Dodeljeni pogoni", primary_factory: "Primarni", load_failed: "Korisnike nije moguće učitati." },
		power_user_allocation: { page_title: "Dodela Power Usera", subtitle: "Pokrivenost država i pogona za odobravanje pristupa Marketplaceu.", refresh: "Osveži", countries: "Države", factories: "Pogoni", power_users: "Power Useri", system_admins: "Administratori sistema", uncovered_plants: "Nepokriveni pogoni", no_power_users: "Nema dodeljenog Power Usera", no_uncovered: "Svi pogoni su pokriveni", gaps: "Praznine" },
		factories: { page_title: "Pogoni", country: "Država", code: "Kod pogona", address: "Adresa", name: "Naziv", search_placeholder: "Traži državu, kod, e-mail ili adresu" },
		products: { page_title: "Proizvodi", name: "Naziv", category: "Kategorija", description: "Opis", article_number: "Broj artikla", filters: "Filteri", search_placeholder: "Traži artikal, naziv ili opis", status: "Status", approved: "Odobreno", pending: "Na čekanju", total_products: "Proizvodi", total: "Ukupno", list_title: "Lista proizvoda", marketplace_price: "Marketplace cena", missing_price: "Nedostaje cena" },
		categories: { page_title: "Kategorije proizvoda", name: "Naziv", status: "Status", approved: "Odobreno", pending: "Na čekanju", total: "Ukupno", list_title: "Lista kategorija" },
		mystocks: { page_title: "Moje zalihe", total_products: "Proizvodi", with_used_quantity: "sa zalihom", search_article: "Traži kod artikla", stock_list: "Lista zaliha", sorted_by_activity: "Sortirano po poslednjoj aktivnosti", total: "Ukupno", filters: "Filteri", import_from_csv: "Uvoz iz CSV fajla:", article_number: "Broj artikla", used_in_stock: "Polovno (kol.)", price: "Cena" },
		dashboard: { page_title: "Kontrolna tabla", available_offers: "Ponude", stock_offers: "Ponude zaliha", sorted_by_id: "Sortirano po najnovijem ID-u", total: "Ukupno", factory_code: "Kod pogona", seller_name: "Prodavac", created_date: "Kreirano", article_info: "Informacije o artiklu", quantity: "Količina", price: "Cena", order: "Naruči", operations: "Radnje", article_code: "Kod artikla:", search_article: "Traži kod artikla", quantity_range: "Raspon količine:", category: "Kategorija", preview_seller: "Prikaži kao prodavac", preview_seller_placeholder: "Izaberite prodavca" },
		myorders: { page_title: "Moje narudžbine", total_orders: "Narudžbine", orders: "Narudžbine", sorted_by_newest: "Sortirano po najnovijem zahtevu", total: "Ukupno", filter_status: "Status", factory_code: "Kod pogona", seller_name: "Prodavac", buyer_name: "Kupac", article_info: "Informacije o artiklu", quantity: "Količina", price: "Cena", operations: "Radnje", approve: "Odobri", reject: "Odbij" },
		report_order: { page_title: "Izveštaj narudžbina", filters: "Filteri", total: "Ukupno", orders: "Narudžbine", excel: "Excel" },
		report_offers: { page_title: "Izveštaj ponuda", available_offers: "Dostupne ponude", total: "Ukupno", empty_results: "Nema ponuda" },
		report_last_stock_update: { page_title: "Status ažuriranja zaliha pogona", subtitle: "Aktivnost zaliha po pogonu i državi, na osnovu stvarnih redova zaliha i vidljivih Marketplace ponuda.", factory: "Pogon", factories: "Pogoni", factories_short: "pogona", country: "Država", countries: "Države", stock_actors: "Aktivni korisnici zaliha", no_stock_actors: "Još nema aktivnosti zaliha", factory_overview: "Pregled pogona", grouped_by_country: "Grupisano po državama sa aktivnošću Marketplace ponuda.", total_factories: "Ukupno", last_update: "Poslednje ažuriranje", days_since_update: "Dana od ažuriranja", days: "Dana", active_offers: "Aktivne ponude", active_articles: "Aktivni artikli", active_quantity: "Otvorena količina", estimated_value: "Procenjena vrednost", needs_attention: "Potrebna pažnja", needs_attention_short: "pažnja", offers_short: "ponuda", pieces_short: "kom", status_current: "Ažurno", status_stale: "Zastarelo", status_never: "Nikad ažurirano", expand_all: "Otvori sve", collapse_all: "Zatvori sve", no_factory_data: "Nema podataka o zalihama pogona", load_failed: "Status ažuriranja zaliha pogona nije moguće učitati.", all_users_are_ok: "Svi pogoni imaju ažurne zalihe", export_to_excel: "Izvoz u Excel", never: "Nikad" },
		report_unordered_products: { page_title: "Nenaručeni proizvodi", subtitle: "Otvorene ponude polovne robe sa dostupnom količinom u poređenju sa aktivnošću narudžbina.", rows: "Redovi", laundries: "Pogoni", open_quantity: "Otvorena količina", never_ordered: "Nikad naručeno", filters: "Filteri", search_placeholder: "Traži pogon, broj artikla ili proizvod", only_never_ordered: "Samo nikad naručeno", refresh: "Osveži", reset: "Resetuj", stock_list: "Zalihe sa malom/bez aktivnosti narudžbina", sorted_by_laundry: "Grupisano po pogonu i artiklu", total: "Ukupno", empty_results: "Nema nenaručenih zaliha", article_info: "Informacije o artiklu", ordering_signal: "Aktivnost narudžbina", has_orders: "Ima narudžbine", load_failed: "Nenaručene proizvode nije moguće učitati.", factory_code: "Pogon", article_number: "Broj artikla", product_name: "Artikal", first_upload_date: "Datum prvog unosa", current_quantity: "Otvorena količina", ordered_quantity: "Naručena količina", export_to_excel: "Izvoz u Excel" },
		imports: { page_title: "Uvozi", import_from_csv: "Uvoz iz CSV fajla:", drop_csv_file_1: "Prevucite fajl ovde ili", drop_csv_file_2: "kliknite za otpremanje" }
	},
	ro: {
		edit: "Editare",
		delete: "Ștergere",
		cancel: "Anulare",
		save: "Salvare",
		confirm: "Confirmare",
		add_item: "Adaugă element",
		confirm_delete: "Acest element va fi șters definitiv. Continuați?",
		warning_title: "Avertizare",
		all: "Toate",
		filter: "Filtrare",
		filters: "Filtre",
		reset: "Resetare",
		operations: "Acțiuni",
		used: "folosit",
		new: "nou",
		accepted: "acceptat",
		pending: "în așteptare",
		rejected: "respins",
		login: {
			title: "Autentificare",
			subtitle: "Autentificare în Marketplace",
			marketplace_title: "Salesianer Marketplace",
			microsoft_subtitle: "Autentificați-vă cu contul Microsoft Salesianer",
			microsoft_button: "Autentificare cu Microsoft",
			sso_unavailable: "Autentificarea Microsoft este temporar indisponibilă.",
			sso_not_configured: "Azure SSO nu este încă configurat.",
			no_access: "Nu aveți încă acces la Marketplace?",
			request_access: "Solicitați acces",
			email_address: "Adresă de e-mail",
			enter_email: "Introduceți e-mailul",
			never_share: "Nu vom transmite e-mailul dvs. nimănui",
			password: "Parolă",
			login_button: "Autentificare"
		},
		request_access: {
			request_title: "Solicitați acces",
			sent_title: "Solicitare trimisă",
			request_subtitle: "Spuneți-ne unde aveți nevoie de acces la Marketplace.",
			sent_subtitle: "Cineva va răspunde cât mai curând posibil.",
			account: "Cont",
			country: "Țară / regiune",
			country_placeholder: "Selectați țara / regiunea",
			factory: "Unitate",
			factory_placeholder: "Selectați unitatea",
			message: "Mesaj",
			message_placeholder: "Rol, unitate sau motiv de business",
			back: "Înapoi",
			submit: "Solicitați acces",
			success_message: "Solicitarea a fost trimisă persoanelor responsabile pentru aprobare.",
			back_to_login: "Înapoi la autentificare",
			send_failed: "Solicitarea nu a putut fi trimisă."
		},
		menu: {
			last_stock_update: "Actualizări stoc unități",
			log_out: "Deconectare",
			dashboard: "Dashboard",
			my_stocks: "Stocurile mele",
			my_orders: "Comenzile mele",
			administration: "Administrare",
			users: "Utilizatori",
			power_user_allocation: "Alocare Power User",
			factories: "Unități",
			right_groups: "Grupuri de drepturi",
			product_categories: "Categorii produse",
			products: "Produse",
			reports: "Rapoarte",
			report_activity: "Comenzi și oferte",
			report_stock_control: "Control stoc",
			unordered_products: "Articole necomandate",
			orders: "Comenzi",
			offers: "Oferte",
			lazy_users: "Utilizatori inactivi",
			settings: "Setări globale",
			change_password: "Schimbare parolă",
			imports: "Importuri",
			lang: "Limbă",
			active_factory: "Unitate",
			primary_factory: "Principal",
			active_factory_changed: "Unitatea activă a fost schimbată",
			my_profile: "Profilul meu"
		},
		users: {
			page_title: "Utilizatori",
			name: "Nume",
			email: "E-mail",
			factory_country: "Țara unității",
			factory_code: "Cod unitate",
			filters: "Filtre",
			search_placeholder: "Căutare nume sau e-mail",
			sso_status: "Status SSO",
			sso_last_login: "Ultima autentificare SSO",
			access_request: "Solicitare acces",
			no_location_selected: "Nicio locație selectată",
			message: "Mesaj",
			approve: "Aprobă",
			block: "Blochează",
			block_confirm: "Blocați această solicitare de acces Microsoft?",
			pending_access: "Acces în așteptare",
			approved_access: "Aprobat",
			blocked_access: "Blocat",
			azure_object_id: "ID obiect Azure",
			dialog_title: "Date utilizator",
			password: "Parolă",
			repeat_password: "Repetați parola",
			user_group: "Grup utilizator",
			user_factory: "Unitatea utilizatorului",
			assigned_plants: "Unități alocate",
			primary_factory: "Principal",
			additional_factories: "Unități alocate",
			additional_factories_placeholder: "Selectați unitățile suplimentare pe care utilizatorul le poate gestiona",
			load_failed: "Utilizatorii nu au putut fi încărcați. Încercați din nou.",
			change_password: "Schimbare parolă",
			wrong_password: "Parolă greșită",
			good_password: "Parolă bună",
			password_change_success: "Parola a fost schimbată cu succes",
			password_dialog_title: "Schimbare parolă"
		},
		power_user_allocation: {
			page_title: "Alocare Power User",
			subtitle: "Acoperirea țărilor și unităților pentru aprobările de acces Marketplace.",
			refresh: "Reîmprospătare",
			countries: "Țări",
			factories: "Unități",
			factories_short: "unități",
			power_users: "Power Useri",
			system_admins: "Administratori sistem",
			uncovered_plants: "Unități neacoperite",
			no_power_users: "Niciun Power User alocat",
			no_uncovered: "Toate unitățile sunt acoperite",
			gaps: "Lipsuri",
			empty: "Nu s-au găsit date de alocare",
			load_failed: "Alocarea Power User nu a putut fi încărcată."
		},
		factories: {
			page_title: "Unități",
			email: "E-mail",
			notify_for_invoice_approval: "Notificare pentru factură la aprobare",
			filters: "Filtre",
			search_placeholder: "Căutare țară, cod, e-mail sau adresă",
			invoice_notification: "Notificare factură",
			notify_enabled: "Notificare activă",
			notify_disabled: "Fără notificare",
			address: "Adresă",
			name: "Nume",
			country: "Țară",
			code: "Cod unitate",
			dialog_title: "Date unitate"
		},
		right_groups: {
			page_title: "Grupuri de drepturi",
			dialog_title: "Date grup de drepturi",
			name: "Nume",
			group_rights: "Drepturile grupului",
			all_rights: "Toate drepturile",
			selected_rights: "Selectate"
		},
		categories: {
			page_title: "Categorii produse",
			name: "Nume",
			old_product_price: "Preț articol folosit",
			proposed_by_user: "Propus de utilizator",
			dialog_title: "Date categorie",
			request_dialog_title: "Solicitare categorie nouă",
			basic_information: "Detalii categorie",
			submit_request: "Trimite solicitarea",
			filters: "Filtre",
			search_placeholder: "Căutare categorie sau propunător",
			approval_status: "Status aprobare",
			status: "Status",
			approved: "Aprobat",
			pending: "În așteptare",
			total_categories: "Categorii",
			total: "Total",
			list_title: "Listă categorii",
			sorted_by_newest: "Sortat după cea mai nouă solicitare",
			empty_results: "Nu s-au găsit categorii",
			load_failed: "Categoriile nu au putut fi încărcate.",
			approve_failed: "Categoria nu a putut fi aprobată.",
			delete_failed: "Categoria nu a putut fi ștearsă.",
			approve: "Aprobă",
			operations: "Acțiuni",
			confirm_approve: "Aprobați această categorie propusă. Continuați?"
		},
		products: {
			page_title: "Produse",
			name: "Nume",
			old_product_price: "Preț articol folosit",
			proposed_by_user: "Propus de utilizator",
			dialog_title: "Date produs",
			request_dialog_title: "Solicitare produs nou",
			basic_information: "Detalii produs",
			product_image: "Imagine produs",
			upload_image: "Încărcare imagine",
			upload_hint: "Fișiere JPG/PNG sub 500 KB",
			preview: "Previzualizare",
			no_image_selected: "Nicio imagine încărcată",
			submit_request: "Trimite solicitarea",
			category: "Categorie",
			description: "Descriere",
			image: "Imagine",
			article_number: "Număr articol",
			filters: "Filtre",
			search_placeholder: "Căutare articol, nume sau descriere",
			approval_status: "Status aprobare",
			status: "Status",
			approved: "Aprobat",
			pending: "În așteptare",
			total_products: "Produse",
			total: "Total",
			list_title: "Listă produse",
			sorted_by_newest: "Sortat după cea mai nouă solicitare",
			empty_results: "Nu s-au găsit produse",
			load_failed: "Produsele nu au putut fi încărcate.",
			approve: "Aprobă",
			confirm_approve: "Aprobați acest produs propus. Continuați?",
			marketplace_price: "Preț Marketplace",
			marketplace_price_hint: "Lăsați gol pentru ca articolul să nu fie utilizabil până la introducerea prețului.",
			missing_price: "Preț lipsă",
			catalog: "Catalog",
			catalog_status: "Status catalog",
			manual_or_legacy: "Manual / existent",
			required_name: "Numele este obligatoriu",
			required_article_number: "Numărul articolului este obligatoriu",
			required_description: "Descrierea este obligatorie",
			required_category: "Categoria este obligatorie",
			required_old_product_price: "Prețul articolului folosit este obligatoriu"
		},
		mystocks: {
			page_title: "Stocurile mele",
			last_modified_date: "Data ultimei modificări",
			first_upload_date: "Data primei încărcări",
			new_products: "Produse noi",
			old_products: "Produse folosite",
			product: "Produs",
			code: "Cod",
			filters: "Filtre",
			filter: "Filtrare",
			reset: "Resetare",
			description: "Descriere",
			stock: "Stoc",
			stocks_updated_with_success: "Stocurile au fost actualizate cu succes.",
			used_in_stock: "Folosit (cant.)",
			new_in_stock: "Nou (cant.)",
			price: "Preț",
			only_available_for_new_products: "Disponibil doar pentru produse noi",
			new_products_in_stock: "Produse noi în stoc",
			used_products_in_stock: "Produse folosite în stoc",
			import_from_csv: "Import din fișier CSV:",
			choose_csv_file: "Alege fișier CSV",
			upload_csv_file: "Încărcare pe server",
			example_csv_file: "Fișier CSV exemplu",
			please_check: "Verificați ",
			columns_used_in_csv: "Coloane: număr articol, cantitate folosită",
			total_products: "Produse",
			with_used_quantity: "cu stoc",
			search_article: "Căutare cod articol",
			stock_list: "Listă stocuri",
			sorted_by_activity: "Sortat după ultima activitate",
			total: "Total",
			empty_results: "Nu s-au găsit produse în stoc",
			upload_errors: "Erori încărcare",
			article_number: "Număr articol",
			load_failed: "Datele de stoc nu au putut fi încărcate.",
			save_failed: "Cantitatea nu a putut fi salvată.",
			laundry_offer_scope: "Oferte pentru unitatea selectată",
			laundry: "Unitate",
			no_laundry_selected: "Nicio unitate selectată",
			create_offer: "Creează ofertă",
			active_offers: "Oferte active",
			available_quantity: "Cantitate disponibilă",
			ordered_quantity: "Cantitate comandată",
			estimated_value: "Valoare estimată",
			usable_products: "Produse utilizabile",
			need_price: "necesită preț",
			last_updated_by: "Actualizat de",
			operations: "Acțiuni",
			close_offer: "Închide oferta",
			confirm_close_offer: "Setați cantitatea acestei oferte la zero și o închideți?",
			publish_offer: "Publică oferta",
			search_product_placeholder: "Căutare număr articol sau nume",
			product_search_starter: "Se afișează articole utilizabile sugerate. Scrieți pentru filtrare.",
			product_search_results: "Articole utilizabile filtrate",
			no_usable_products_found: "Nu s-au găsit produse utilizabile",
			marketplace_offers: "oferte active",
			existing_offer: "Ofertă existentă",
			offer_saved: "Oferta a fost salvată.",
			product_search_failed: "Produsele nu au putut fi căutate.",
			select_product_first: "Selectați mai întâi un articol.",
			enter_quantity_first: "Introduceți o cantitate."
		},
		dashboard: {
			page_title: "Dashboard",
			unique_id: "Id",
			factory_code: "Cod unitate",
			seller_name: "Vânzător",
			created_date: "Creat",
			article_info: "Informații articol",
			order_status: "Status comandă",
			product_status: "Status",
			quantity: "Cantitate",
			price: "Preț",
			order: "Comandă",
			own_offer: "Oferta mea",
			own_offer_hint: "Aceasta este oferta unității active și nu poate fi comandată aici.",
			operations: "Acțiuni",
			article_code: "Cod articol:",
			search_article: "Căutare cod articol",
			quantity_range: "Interval cantitate:",
			min_quantity: "Min",
			max_quantity: "Max",
			category: "Categorie",
			preview_seller: "Vizualizare ca vânzător",
			preview_seller_placeholder: "Selectați vânzătorul",
			used: "Folosit",
			new: "Nou",
			status: "Status",
			available_offers: "Oferte",
			total: "Total",
			stock_offers: "Oferte de stoc",
			sorted_by_id: "Sortat după cel mai nou ID",
			empty_results: "Nu s-au găsit oferte de stoc"
		},
		buy_dialog: {
			dialog_title: "Comandă nouă",
			quantity: "Cantitate",
			price: "Preț",
			request_value: "Valoare solicitată",
			confirm_order: "Confirmă comanda"
		},
		myorders: {
			page_title: "Comenzile mele",
			unique_id: "Id",
			filter_status: "Status",
			factory_code: "Cod unitate",
			seller_name: "Vânzător",
			buyer_name: "Cumpărător",
			buyer_factory_code: "Unitate cumpărător",
			article_info: "Informații articol",
			order_status: "Status comandă",
			product_status: "Status",
			request_date: "Data solicitării",
			quantity: "Cantitate",
			price: "Preț",
			order: "Comandă acum",
			operations: "Acțiuni",
			approve: "Aprobă",
			reject: "Respinge",
			are_you_sure_you_approve: "Sigur doriți să aprobați această comandă?",
			attention_you_need_to_attach_invoice_to_delivery: "Atenție! Trebuie să atașați factura la avizul de livrare.",
			rejection_reason: "Motiv respingere",
			wrong_validate_reason: "Motiv invalid.",
			no_action: "Nicio acțiune.",
			download_delivery_note: "Aviz de livrare",
			reason: "Motiv",
			total_orders: "Comenzi",
			orders: "Comenzi",
			sorted_by_newest: "Sortat după cea mai nouă solicitare",
			total: "Total",
			empty_results: "Nu s-au găsit comenzi",
			load_failed: "Comenzile nu au putut fi încărcate."
		},
		report_unordered_products: {
			page_title: "Produse necomandate",
			subtitle: "Oferte deschise de stoc folosit cu cantitate disponibilă, comparate cu activitatea comenzilor.",
			rows: "Rânduri",
			laundries: "Unități",
			open_quantity: "Cantitate deschisă",
			never_ordered: "Niciodată comandat",
			filters: "Filtre",
			search_placeholder: "Caută unitate, număr articol sau produs",
			only_never_ordered: "Doar niciodată comandate",
			refresh: "Reîmprospătare",
			reset: "Resetare",
			stock_list: "Stocuri cu activitate redusă/fără comenzi",
			sorted_by_laundry: "Grupat după unitate și articol",
			total: "Total",
			empty_results: "Nu s-au găsit stocuri necomandate",
			article_info: "Informații articol",
			ordering_signal: "Activitate comenzi",
			has_orders: "Are comenzi",
			load_failed: "Produsele necomandate nu au putut fi încărcate.",
			factory_code: "Unitate",
			article_number: "Număr articol",
			product_name: "Articol",
			first_upload_date: "Data primei încărcări",
			current_quantity: "Cantitate deschisă",
			ordered_quantity: "Cantitate comandată",
			export_to_excel: "Export în Excel"
		},
		report_order: {
			page_title: "Raport comenzi",
			total_orders: "Comenzi",
			orders: "Comenzi",
			total: "Total",
			sorted_by_id: "Sortat după cel mai nou ID",
			empty_results: "Nu s-au găsit comenzi",
			unique_id: "Id",
			dates: "Date",
			factory_code: "Cod unitate",
			seller_name: "Vânzător",
			article_info: "Informații articol",
			order_status: "Status comandă",
			product_status: "Status",
			quantity: "Cantitate",
			request_date: "Data solicitării",
			buyer_name: "Cumpărător",
			buyer_factory_code: "Unitate cumpărător",
			price: "Preț",
			order: "Comandă acum",
			operations: "Acțiuni",
			approve: "Aprobă",
			reject: "Respinge",
			are_you_sure_you_approve: "Sigur doriți să aprobați această comandă?",
			rejection_reason: "Motiv respingere",
			wrong_validate_reason: "Motiv invalid.",
			no_action: "Nicio acțiune.",
			download_delivery_note: "Aviz de livrare",
			filters: "Filtre",
			reset: "Resetare",
			article_code: "Cod articol:",
			search_article: "Căutare cod articol",
			category: "Categorie",
			all: "Toate",
			accepted: "Acceptată",
			approved: "Aprobată",
			rejected: "Respinsă",
			pending: "În așteptare",
			buyer: "Cumpărător",
			seller: "Vânzător",
			excel: "Excel",
			reason: "Motiv"
		},
		report_offers: {
			page_title: "Raport oferte",
			available_offers: "Oferte disponibile",
			latest_offers: "Oferte recente",
			sorted_by_id: "Sortat după cel mai nou ID",
			total: "Total",
			offer_id: "Id",
			created: "Creat",
			factory: "Unitate",
			seller: "Vânzător",
			article_info: "Informații articol",
			status: "Status",
			quantity: "Cantitate",
			price: "Preț",
			excel: "Excel",
			empty_results: "Nu există oferte"
		},
		report_last_stock_update: {
			page_title: "Status actualizare stoc pe unitate",
			subtitle: "Activitate de stoc la nivel de unitate, grupată pe țări, pe baza rândurilor reale de stoc și ofertelor vizibile în Marketplace.",
			user: "Utilizator",
			factory: "Unitate",
			factories: "Unități",
			factories_short: "unități",
			country: "Țară",
			countries: "Țări",
			responsible_power_users: "Power Useri responsabili",
			stock_actors: "Utilizatori activi pe stoc",
			no_stock_actors: "Încă nu există activitate de stoc",
			factory_overview: "Prezentare unități",
			grouped_by_country: "Grupat pe țări cu activitatea ofertelor Marketplace curente.",
			total_factories: "Total",
			last_update: "Ultima actualizare",
			days_since_update: "Zile de la actualizare",
			days: "Zile",
			active_offers: "Oferte active",
			active_articles: "Articole active",
			active_quantity: "Cantitate deschisă",
			estimated_value: "Valoare estimată",
			needs_attention: "Necesită atenție",
			needs_attention_short: "atenție",
			offers_short: "oferte",
			pieces_short: "buc.",
			status_current: "Actual",
			status_stale: "Învechit",
			status_never: "Niciodată actualizat",
			expand_all: "Extinde tot",
			collapse_all: "Restrânge tot",
			no_factory_data: "Nu s-au găsit date de stoc pentru unități",
			load_failed: "Statusul actualizării stocului pe unitate nu a putut fi încărcat.",
			all_users_are_ok: "Toate unitățile au actualizări recente de stoc",
			export_to_excel: "Export în Excel",
			never: "Niciodată"
		},
		report_lazy_users: {
			page_title: "Raport utilizatori inactivi",
			inactive_users: "Utilizatori inactivi",
			user: "Utilizator",
			factory: "Unitate",
			all_users_are_ok: "Toți utilizatorii sunt în regulă",
			days_since_last_login: "Zile de la ultima autentificare",
			days_since_request: "Zile de la ultima solicitare",
			buyer: "Cumpărător",
			buyer_factory: "Unitate cumpărător",
			days: "Zile",
			not_responding_users: "Utilizatori care nu răspund",
			inactive_users_export_to_excel: "Export utilizatori inactivi în Excel",
			not_responding_users_export_to_excel: "Export utilizatori fără răspuns în Excel",
			last_update: "Ultima actualizare",
			never: "Niciodată"
		},
		imports: {
			page_title: "Importuri",
			import_from_csv: "Import din fișier CSV:",
			drop_csv_file_1: "Trageți fișierul aici sau",
			drop_csv_file_2: "clic pentru încărcare",
			file_limit: "fișiere CSV mai mici de 500 KB"
		},
		form_errors: {
			email_required: "Câmpul e-mail este obligatoriu",
			address_required: "Câmpul adresă este obligatoriu",
			country_required: "Câmpul țară este obligatoriu",
			short_code_required: "Câmpul cod unitate este obligatoriu"
		},
		rights: {
			manage_right_groups: "Gestionare grupuri de drepturi",
			manage_users: "Gestionare utilizatori",
			manage_factories: "Gestionare unități",
			manage_categories: "Gestionare categorii",
			manage_products: "Gestionare produse",
			global_settings: "Setări globale",
			access_reports: "Acces rapoarte",
			admin_menu_visible: "Meniu administrare vizibil",
			reports_menu_visible: "Meniu rapoarte vizibil"
		}
	}
};

const localLanguageMessages = {};
Object.keys(localLanguageOverrides).forEach(function(locale) {
	var baseOverride = translatedUiOverrides[locale] || {};
	var override = mergeMessages(baseOverride, localLanguageOverrides[locale]);
	localLanguageMessages[locale] = mergeMessages(messages.en, override);
});

export default Object.assign({}, messages, localLanguageMessages);
